import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';


import { BackendApiService } from "../../app/services/backend-api.service";

import { BaseUrlConstantsService } from "../../app/services/base-url-constants.service";
import { ChangeUsersService } from "../../app/services/change-users.service";
import { appConfig } from "../../app/app.config";
import {
  HttpClientModule,
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpEventType,
} from "@angular/common/http";
import {
  AbstractControl,
  FormControl,
  FormBuilder,
  Validators,
  FormGroup,
} from "@angular/forms";
import predicationChartObject from "./chart-model/prediction_chart"
import { MatSnackBar, MatSnackBarModule } from "@angular/material/snack-bar";
import { MatDialogModule} from '@angular/material/dialog';

import { NgxSpinnerModule } from 'ngx-spinner';
import { AngularCsv } from "angular7-csv/dist/Angular-csv";
import * as CanvasJS from "./canvasjs.stock.min";
import * as fftChartObject from "./chart-model/fft_chart";
import { cloneDeep } from "lodash";
import { FileUploader, FileSelectDirective } from "ng2-file-upload";
import { from } from "rxjs";
// import { NgxJsonViewerModule } from "ngx-json-viewer";
import { NgxSpinnerService } from "ngx-spinner";
// import { MatDialog } from "@angular/material/dialog";
// import { FormControl } from '@angular/forms';
import { ConvertDatetimePipe } from "../../app/convert-datetime.pipe";
import moment from 'moment';
import { CommonModule } from "@angular/common";
import { AddcallibrationComponent } from "../addcallibration/addcallibration.component";
import { DialogPopupComponent } from "../dialog-popup/dialog-popup.component";
import { formatDate } from "@angular/common";
import { ReactiveFormsModule } from '@angular/forms';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { FormsModule } from '@angular/forms';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { MatButtonModule } from "@angular/material/button";
// import { environment } from "src/environments/environment";
//import { AddcallibrationComponent } from "../../dialog-overview-example-dialog/dialog-overview-example-dialog.component";
// import { NgForm } from '@angular/forms'
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from "@angular/material/radio";
import { MatInputModule } from "@angular/material/input";
export interface DialogData {
  popContent: string;
  userRoll: string;
  parentFunction: (arg: any) => void;
}

@Component({
  selector: "app-dialog-overview-example-dialog",
  templateUrl: "./dialog-overview-example-dialog.component.html",
  styleUrls: ["./dialog-overview-example-dialog.component.scss"],
  standalone: true,
  imports: [MatInputModule,MatDialogModule ,CommonModule,ReactiveFormsModule,NgxJsonViewerModule,FormsModule,MatMenuModule,NgbPopoverModule,NgbDatepickerModule, MatButtonModule,MatRadioModule],
  providers:[FormControl]
})
export class DialogOverviewExampleDialogComponent implements OnInit {
  selectedValue1: any = "24 hr";
  public popContent: string = '';
  public parentFunction!: (arg: any) => void;
  public showLicense!: () => void;
  public masterType: any = localStorage.getItem('masterType');

  public savecallibrationdata!: () => void;
  public goToDetailScreen!: (device:any) => void;

  @ViewChild("myInputFile1", { static: false }) myInputVariable: ElementRef;
  public alertSaveButton: boolean = false;
  alertSaveButtonDefault: boolean = false;
  isChecked: boolean = false;
  public auditAlertArr: any = [];
  public isFormModified:boolean = false;
  communicationType = appConfig.communicationType;
  userRoll: string = '';
  public tempConstantArr: any = [
    {
      id: 1,
      catId: 1,
      roleId: 1,
      alertTypeId: 1,
      asset_id: 20,
      client_id: 150,
      event_counter: "2",
      event_fire_at: 24,
    },
    {
      id: 2,
      catId: 1,
      roleId: 1,
      alertTypeId: 1,
      asset_id: 20,
      client_id: 150,
      event_counter: "2",
      event_fire_at: 24,
    },
  ];

  public serviceCategory: string = "";
  public newServiceType: string = "";
  shouldShow: boolean = false;
  showDropDown: boolean = false;
  public showOther: boolean = false;
  public postCheckedData: any = [];
  hideAllSetBtn: boolean = false;
  // isChecked: boolean = false;
  public makeUpdatedisable: boolean = false;
  LicenceStatus: boolean = false;
  public productionKey = BaseUrlConstantsService.PRODUCTION_KEY;
  public alertBaseUrl = BaseUrlConstantsService.BASE_ALERT_URL;
  public checkLicenceAvailability = BaseUrlConstantsService.CHECK_AVAILABILITY;
  public associateDevicesInfo = BaseUrlConstantsService.ASSOCIATE_DEVICES_INFO;
  public associateSite = BaseUrlConstantsService.ASSOCIATE_SITE_USER;
  public imageAssetUploadUrl = BaseUrlConstantsService.ASSET_IMAGE_UPLOAD;
  public userListingUrl = BaseUrlConstantsService.END_USER_LIST;
  public siteUsersListingUrl = BaseUrlConstantsService.SITE_USERS_LIST;
  private getInventoryByIDUrl = BaseUrlConstantsService.GET_INVENTORY_BY_ID;
  public deviceStatusURL = BaseUrlConstantsService.INVENTORY_URL;
  public assetMatricsUrl = BaseUrlConstantsService.ASSET_METRICS;
  public deleteFWVersion = BaseUrlConstantsService.GET_INVENTORY_BY_ID;
  public plantInfoUrl = BaseUrlConstantsService.BASE_PLANT;
  public fftBaseValue: string = "VEL";
  public uploader: FileUploader;
  public wifiVersionUploader: FileUploader;
  public poDateFronSelectDate: any;
  private middleware_url = BaseUrlConstantsService.BASE_MIDDLEWARE_SELF;
  public getLicenseURL = BaseUrlConstantsService.LICENCE_URL;
  public createLicenceUrl = BaseUrlConstantsService.LICENCE_URL;
  public editLicenceUrl = BaseUrlConstantsService.LICENCE_URL;
  public updateLicenceUrl = BaseUrlConstantsService.LICENCE_URL;
  public siteMaintenanceApi = BaseUrlConstantsService.siteMaintenanceApi;
  public productListingUrl = BaseUrlConstantsService.PRODUCTLIST;
  public deviceCategoryUrl = BaseUrlConstantsService.DEVICE_CATEGORY;
  public getModbusNumberUrl = BaseUrlConstantsService.MODBUS_NUMBER;
  public assetServiceUrl=BaseUrlConstantsService.BASE_ASSET_OUT_OF_SERVICE; // this url is specific for sending device out for service only
  public piezo_srv_url = BaseUrlConstantsService.BASE_PIEZO_SERVICE
  public dialog_type: any;
  public userInfo: any;
  public deviceInfo: any;
  public _imgUrl: any;
  public isDisable = true;
  public isReading1: any;
  public isReading2: any;
  public isReading3: any;
  public isReading4: any;
  public isReading5: any;
  public minDates: any;
  public selectedValue: any;
  public alertCategory: any = [];
  public description: any;
  public userList: any;
  valueSelectedFor: string = "";
  public assetInfo: any;
  public datepodate: any;
  public msgLimit: string="";
  public uForm: any;
  onoffStatus: number = 0;
  public assetsInfo: any;
  public deviceStausInfo: any;
  public allValues: any;
  public nbody: any;
  public term: any;
  public clientsList: any;
  public deviceCount: any;
  public _client_asset_id: any;
  public _clientAId: any;
  public selectedClientName = "";
  public _driveTemps: any = [];
  public _rmsAccels: any = [];
  public _userData: any = [];
  public master_products: any = [];
  public _clienId: any;
  auditData: any;
  errorLogData: any;
  serviceLogData: any;
  public _deviceIds: any;
  tempMainMatricsValue: any = [];
  public _lastUpdate: any;
  public _greenIcon: boolean = false;
  public _yellowIcon: boolean = false;
  public _redIcon: boolean = false;
  public _greenRmsIcon: boolean = false;
  public _yellowRmsIcon: boolean = false;
  public _redRmsIcon: boolean = false;
  public quantityPreValue: any = {};
  public selectedValueMoter: any;
  public listNamesChecked: any = [];
  public siteId: any;
  public applicationId: any;
  public _associateUsers: any;
  public _sensorGroupData: any = [];
  public sensorKWpowerGroupData: any = [];
  public myData: any = {};
  public deviceTypeArr: any = [];
  public deviceLicence: any = [];
  public typeArray: any = [];
  public alertSelectionArr = [];
  public plantDATA: any = [];
  public tabColor1: any = "active";
  public tabColor2: any;
  public tabColor3: any;
  public inventoryID: any;
  public tabColor4: any;
  public inventoryForm: any;
  public kurt_threshold: any;
  public kurt_freq: any;
  public kurt_anomaly_counter: any;
  public showKurtosis: boolean = true;
  device_version: string = "";
  wifi_device_version: string = "";
  fileName: any;
  disableChooseBtn: boolean = false;
  percentDone: any;
  public tabColor5: any;
  public fileUploadUrl = BaseUrlConstantsService.FILE_UPLOAD;
  text: string ="";
  assetType = "MOTOR";
  assetData: any = {};
  public isAllSelected: boolean = false;
  selectedInventoryArr: any = [];
  versionsList: any = [];
  HealthindicesForm: any;
  assetsurl: string = BaseUrlConstantsService.BASE_ASSETS_URL;
  asset_id: string = "";
  Baseurl: string = "";
  base_middleware_url: string;
  assetID: any;
  AlertSettingsforasset: boolean = false;
  userid;
  any="";
  public serialNumber="";
  sitename: any;
  appname: any;
  AlertCategory: any;
  assetId: any;
  comments: any;
  emptycommentmsg: string = "";
  alert_id: any;
  alertComment: any = "";
  public accelsensorData: any = BaseUrlConstantsService.Accel_Sensor_Data;
  deviceId: string = "";
  batterystatus: any;
  chartOne: any;
  chart: any;
  datadiagKurtPoints2: any;
  datadiagKurtPoints1: any;
  datadiagKurtPoints3: any;
  specchart: any;
  magnetFieldNoDataMsg: string = "";
  showDiagnosticChartEmpty: boolean = false;
  dataPreKurtPointsNew1: any;
  dataPreKurtPointsNew2: any;
  dataPreKurtPointsNew3: any;
  emptyMsgAlertKurt2: boolean = false;
  showPredAcousticsChartEmpty: boolean = false;
  absolutePercentageAcoustics: any;
  statusAcousticsPredictionValues: any;
  dataAcoustics1: any;
  dataAcousticsPred1: any;
  batterystatuschart: any;
  listPredAcousticsData1: any[] =[];
  chartLayoutOn: boolean = false;
  min_g: number = 0;
  max_g: number=0;
  max_y: number=0;
  max_r: number=0;
  public greenColor: string = "rgb(212, 237, 218)";
  public yellowColor: string = "rgb(255, 250, 196)";
  public redColor: string = "rgb(255, 230, 230)";
  chartLayoutOff: boolean = false;
  callibrateform: any;
  savecallibration: boolean = false;
  MAC: any;
  countcalib: number = 1;
  dialogReff!: MatDialogRef<DialogPopupComponent, any>;
  dialogReffstart!: MatDialogRef<DialogPopupComponent, any>;
  configtime: any;
  devicestatus: any;
  startdisable: boolean = false;
  calibstop: boolean = false;
  calibcompletemessage: string = "";
  unchangedValueArr: any = [];
  commentOnSetting: string = "";
  public device_raw_matric_id: any;
  maintenanceForm: any;
  public startDate: any | null = null;
  public endDate!: Date;
  public availableDate: any;
  public publishDate!: Date ;
  public maintenanceStatus: any;
  public minStart: any;
  public maxPub: any;
  public minEnd: any;
  public minPub: any;

  public productsList: any= [];
  public selectedProductId: number | null = null;
  public device_start_number: number |null = null;
  public number_connection_used: any | null = null;
  public boud_rate:any | null = null;
  public deviceNumberRange: number[] = [];
  public deviceConnectionRange: number[] = [];
  public showAdditionalFields:boolean = true;
  public modbusNumber2ndNumber: number = 0;
  public disableSensor=true;

  public modbusDeviceMaxNumber: number=0;
  public editType: string="";
  public outForServiceData=null;
  public outForServiceAuditData=null;
  public correctMetricValues={
    accelration:true,
    temperature:true,
    audible:true,
    sound:true
  }

  public disabledAlertSettingsColumn: any = {
    user: {
      time: false,
      event: false
    },
    client: {
      time: false,
      event: false
    }
  };
  public alertCategoryTypeIds: any = {
    id1: 0,
    id2: 0
  };
  public alertCategoryRoleIds: any = {
    userId: 0,
    clientAdminId: 0
  }
  public activeCellOfAlertSettings: any = {
    user: false,
    clientAdmin: false
  }
  public initialLoadAlertSettings = true;
  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private eRef: ElementRef,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogOverviewExampleDialogComponent>,
    private alertDialogRef: MatDialogRef<DialogOverviewExampleDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    public router: Router,
    private http: HttpClient,
    private service: BackendApiService,
    private _snackBar: MatSnackBar,
    private changeService: ChangeUsersService,
    public activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder
  ) {
    dialogRef.disableClose = true;
    alertDialogRef.disableClose = true;
    this.callibrateform = this.formBuilder.group({
      rr1: new FormControl(),
      tr1: new FormControl(),
      ar1: new FormControl(),
      rr2: new FormControl(),
      tr2: new FormControl(),
      ar2: new FormControl(),
      rr3: new FormControl(),
      tr3: new FormControl(),
      ar3: new FormControl(),
      rr4: new FormControl(),
      tr4: new FormControl(),
      ar4: new FormControl(),
      rr5: new FormControl(),
      tr5: new FormControl(),
      ar5: new FormControl(),
    });

    let date = new Date();
    this.setMinStart();
    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.availableDate = tomorrow.toISOString().slice(0, 16);
    const days = date.getDate();
    const months = date.getMonth() + 1;
    const years = date.getFullYear();
    this.minDates = { year: years, month: months, day: days };
    this.base_middleware_url = BaseUrlConstantsService.BASE_MIDDLEWARE_URL;
    this.uploader = new FileUploader({
      url: BaseUrlConstantsService.FILE_UPLOAD + "/fota",
      itemAlias: "photo",
    });
    this.wifiVersionUploader = new FileUploader({
      url: BaseUrlConstantsService.FILE_UPLOAD + "/fota/wifi",
      itemAlias: "photo",
    });
    this.dialog_type = data.type;
    if (data.type === "deleteFWVersionDialogBox") {
      this.versionsList = JSON.parse(JSON.stringify(data)).data.versions;
      for (var i = 0; i < this.versionsList.length; i++) {
        this.versionsList[i].isSelected = false;
      }
    }

    if (data.type === "BAtterystatusgraph") {
      let MacAddress = data.mac_address;
      this.batterystatusgraph(MacAddress);
    }

    if (data.type === "plantDailogBox") {
      this.plantDATA = data.plant_data;
      for (let i = 0; i < data.plant_data.length; i++) {
        this.plantDATA[i].last_service =
          new ConvertDatetimePipe().convertDateTime(
            moment.utc(this.plantDATA[i].last_service).local()
          );
      }
    }

    if (data.type === "AlertBookOpen") {
      console.log(data);
      this.assetID = data.data.assetid;
      this.userid = data.data.clientid;
      this.alert_id = data.data.report.alert_id;
      this.getalertcommentbyid(data.data.report.device_raw_matric_id);
      this.device_raw_matric_id = data.data.report.device_raw_matric_id;
    }
    if (data.type === "VibratioCallibrate") {
      this.assetID = data.assetid;
      this.MAC = data.macadress;
      this.deviceId = data.deviceid;
      this.configtime = data.configtime;
      this.devicestatus = data.devicestatus;

      this.savecallibration = true;
      if (this.devicestatus == 0 || this.devicestatus == 1) {
        this.startdisable = false;
      } else {
        this.startdisable = true;
      }
    }
    if (data.type === "AlertSettingsforasset") {
      this.sitename = data.sitename;
      this.appname = data.applicationname;
      const clientID = data.clientId;
      const assetId = data.assetId;
      this.assetId = data.assetId;
      this.AlertSettingsforasset = true;
      this.getClientLevelassetAlertSettings(clientID, assetId);
    }

    if (data.type === "NotifyAlertStstem") {
      const assetID = data.assetId;
      const clientID = data.clientId;
      const deviceID = data.deviceId;
      this.assetData["inventory_id"] = deviceID;
      this.assetData["asset_id"] = assetID;
      this.assetData = data.asset_obj;
      this.getAllAlertSettings(assetID, clientID, deviceID);
    }

    if (data.type === "DefaultClientAlertStstem") {
      const clientID = data.clientId;
      this.getClientLevelAlertSettings(clientID);
    }
    if (data.type === "Update Weightage") {
      this.HealthindicesForm = this.formBuilder.group({
        Mechanical_Health: new FormControl(""),
        Bearings_Health: new FormControl(""),
        Electrical_Health: new FormControl(""),
        Thermal_Health: new FormControl(""),
      });
      const assetId = data.assetid;
      this.assetID = assetId;
      this.assetData["inventory_id"] = this.assetID;
      this.getHealthIndies(assetId);
    }

    if (this.dialog_type === "sensorNewDialogBox") {
      this.assetType = data.asset_type;
      this.inventoryID = data.inventory_id;
      this.assetData = data.asset_obj;
      this.showKurtosis = data.showKurtosis;
      this.kurt_freq = data.kurt_freq;
      this.kurt_threshold = data.kurt_threshold;
      this.kurt_anomaly_counter = data.kurt_anomaly_counter;
      // console.log("THIS>SHOW_KURTOSIS:" + data.showKurtosis);
      // console.log(this.kurt_anomaly_counter);
      // console.log(this.kurt_freq);
    }

    if(this.dialog_type==='showOutOfServiceDialogInitially'){
      this.serialNumber=data.serialNumber
    }

    let tempVal = [];
    if (this.dialog_type === "auditDialogBox") {
      const propertyNames = Object.keys(JSON.parse(data.asset_obj));
      const propertyValues = Object.values(JSON.parse(data.asset_obj));
      for (let i = 0; i < propertyNames.length; i++) {
        let key = JSON.parse(JSON.stringify(propertyNames[i])).replaceAll(
          "_",
          " "
        );
        for (let j = 0; j < propertyValues.length; j++) {
          let value = propertyValues[i];
          let obj:any = {};
          obj[`${this.camalize(key)}`] = value;
          tempVal.push(obj);
          break;
        }
      }
      this.auditData = Object.assign({}, ...tempVal);
    }

    if (this.dialog_type === "errorLogDialogBox") {
      this.errorLogData = {
        alertCategory: this.data.error_log.alert_category,
        alertCommentsHistory: this.data.error_log.alert_comments_history,
      };
    }

    if (this.dialog_type === "serviceLogDialogBox") {
      this.serviceLogData = {
        serviceDetail: this.data.service_log.service_detail,
        lastServicePerformed: this.data.service_log.last_service_performed,
        // ... include other fields you wish to display ...
      };
    }

    if (this.dialog_type === "addLicenseDailogBox") {
      this.deviceTypeArr = data.deviceTypeData;
      this.service.getDataWithQuery(this.getLicenseURL).then((res) => {
        const result = JSON.parse(JSON.stringify(res));
        if (result.data.status === "success") {
          if (result.data.body.length !== 0) {
            this.selectedValueMoter = result.data.body.find(
              (item:any) =>
                parseInt(item.device_type_id) ===
                parseInt(data.deviceTypeData[0].id)
            );
            this.quantityPreValue = this.selectedValueMoter;
          }
        } else {
          this.service.showError("Something went wrong.");
        }
      });
    }

    if (this.dialog_type === "deviceTypeDailogBox") {
      this.deviceLicence = data.deviceDataArray;
    }
    if (this.dialog_type === "siteSchedule") {
      this.maintenanceStatus = data.status;
      if (data.status === "editLog") {
        this.startDate = new ConvertDatetimePipe().convertDateTime(
          moment.utc(data?.values?.start_date).local()
        );
        this.publishDate = new ConvertDatetimePipe().convertDateTime(
          moment.utc(data?.values?.publish_date).local()
        );
        this.endDate = new ConvertDatetimePipe().convertDateTime(
          moment.utc(data?.values?.end_date).local()
        );
        this.maintenanceForm = this.formBuilder.group({
          title_val: new FormControl(
            data?.values?.title ? data?.values?.title : "N/A",
            [Validators.required]
          ),
          description: new FormControl(
            data.values.description ? data.values.description : "N/A"
          ),
          start_date: [
            formatDate(this.startDate, "yyyy-MM-dd hh:mm:ss", "en"),
            [Validators.required],
          ],
          end_date: [
            formatDate(this.endDate, "yyyy-MM-dd hh:mm:ss", "en"),
            [Validators.required],
          ],
          publish_date: [
            formatDate(this.publishDate, "yyyy-MM-dd hh:mm:ss", "en"),
            [Validators.required],
          ],
        });
      } else {
        this.maintenanceForm = this.formBuilder.group({
          title_val: new FormControl("", [Validators.required]),
          description: new FormControl(""),
          start_date: new FormControl("", [Validators.required]),
          end_date: new FormControl("", [Validators.required]),
          publish_date: new FormControl("", [Validators.required]),
        });
      }
    }
    if (data !== undefined) {
      if (data.data !== undefined) {
        this.allValues = data.data;
      }

      if (data.asset_id !== undefined) {
        this.showAssetImage(data.asset_id);
      }
    }
    this._lastUpdate = data.lastUpdate;
    if (data.clientDataList !== undefined) {
      this.clientsList = data.clientDataList;
      this.clientsList.unshift({ full_name: "Select client." });
    }

    if (data.selectionCount !== undefined) {
      this.deviceCount = data.selectionCount;
    }

    if (data.deviceIds !== undefined) {
      this._deviceIds = data.deviceIds;
    }

    if (data.machineInfo !== undefined) {
      this.assetInfo = data.machineInfo;
    }
    this.userInfo = data.userInfo;
    this._client_asset_id = data.client_asset_id;
    this.inventoryID = data.inventory_id;
    this._clientAId = data.clientId;
    if (data.deviceStatus !== undefined) {
      this.deviceStausInfo = data.deviceStatus.data.body;

      localStorage.setItem("lineFreq", this.deviceStausInfo.line_frequency);
      localStorage.setItem("rated_rpm", this.deviceStausInfo.rated_rpm);
      localStorage.setItem("siteName", this.deviceStausInfo.site.name);
      localStorage.setItem(
        "serialNumber",
        this.deviceStausInfo.motor_serial_no
      );
      localStorage.setItem(
        "appMacAdd",
        this.deviceStausInfo.device.mac_address
      );
    }
    this.description = data.des;
    this.userList = data.userList;
    if (data.type === "ClientGroupAssociateUsers") {
      let count = 0;
      for (let i = 0; i < this.userList.length; i++) {
        if (this.userList[i].checked) {
          count++;
          if (count === this.userList.length) {
            this.isChecked = true;
          }
        } else {
          this.isChecked = false;
        }
      }
    }

    if(data.type=='outOfServiceConfirmation'){
      this.outForServiceData=data.data.outOfServiceData;
      this.outForServiceAuditData={...data.data.outOfServiceData,...data.data.auditData}
    }

    this._userData = data.userList;
    this.siteId = data.siteid;
    this.applicationId = data.group_id;
    this._associateUsers = data._associateUsers;

    // Fetch products list.
    this.service.getDataWithQuery(this.deviceCategoryUrl).then((res) => {

      const result = JSON.parse(JSON.stringify(res));
        if (result.data.status === "success") {
          if (result.data.body.body.length !== 0) {

            this.productsList = result.data.body.body;
          }
        } else {
          this.service.showError("Something went wrong.");
        }

    });


    //Fetch Maximum Modbus Number.
    //this.getModbusNumberUrl
    //"http://localhost:3004/get_modbus_device_numbers"
    this.service.getDataWithQuery(this.getModbusNumberUrl).then((res) => {

      const result = JSON.parse(JSON.stringify(res));
        if (result.data.status === "success") {
          if (result.data.body.body.length !== 0) {

            let modbusNumberArray = result.data.body.body;

            const filteredArr = modbusNumberArray.filter((num:any) => num !== null);

            // Get the max value from the filtered array
            if(Math.max(...filteredArr) >0){
              this.modbusDeviceMaxNumber = Math.max(...filteredArr);
              this.modbusDeviceMaxNumber = this.modbusDeviceMaxNumber+5;
            }

            // Energymeter Configurator device_start_number Range From 100 to 200.
            this.deviceNumberRange = Array.from({ length: 1 }, (_, i) => this.modbusDeviceMaxNumber + i * 5);
            // this.deviceNumberRange=[106]

            // Energymeter Configurator device number_of_connection range.
            this.deviceConnectionRange = Array.from({length: 5}, (_, i) => i + 1);

          }
        } else {
          this.service.showError("Something went wrong.");
        }

    });

    if(data.type === "addNewDeviceDailogBox"){
      data.config_mapping="no";
      data.device_category_id=null;
      data.device_start_number=null;
      data.number_of_connection=null;
      data.communication_type=null;
      data.is_piezo=0;

    }

    if(data.type === "editNewDevicePop"){

      if(data.data.device_category_id==1){
        this.editType = 'Rotating Asset';
      }else if(data.data.device_category_id == 3){
        this.editType = 'Energy Meter';
      }else if(data.data.device_category_id==5){
        this.editType = 'Gateway';
      }
      if(data.data.device_category_id==1 || data.data.device_category_id==5 || data.data.device_category_id==4){
        this.showAdditionalFields = false;
      }
      if(data.data.device_start_number>0){
        this.modbusNumber2ndNumber = Number(data.data.device_start_number);

        // Now add 4 to it
        this.modbusNumber2ndNumber = this.modbusNumber2ndNumber + 4;
      }


    }



  }

  onFieldChange() {
    this.isFormModified = true;
  }

   onProductTypeChange(event:any) {

    this.isFormModified = true;
    const selectedProductType = event.target.value;

    if(selectedProductType == 1 || selectedProductType == 4 ||  selectedProductType == 5){
      this.showAdditionalFields = false;
    }else{
      this.showAdditionalFields = true;
    }
  }

  onGatewayTypeChange(event:any){
    console.log(event.target.value);
    let gateway_type=event.target.value
    if(gateway_type=='Piezo') this.data.is_piezo=1;
    // else
  }

  onCommunicationTypeChange(event){

    this.isFormModified = true;
    const selectedCommunicationType = event.target.value;

  }

  setMinStart(): void {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1);
    this.minStart = currentDate.toISOString().slice(0, 16);
    currentDate.setDate(currentDate.getDate() - 1);
    this.minPub = currentDate.toISOString().slice(0, 16);
    // this.setPublish();
  }

  setPublish(): void {
    const maxPublishDate = new Date(this.maintenanceForm.value.start_date);
    maxPublishDate.setDate(maxPublishDate.getDate());
    this.maxPub = maxPublishDate.toISOString().slice(0, 16);
  }
  subscribeToStartDateChanges(): void {

    const startDateControl = this.maintenanceForm.get("start_date");
    if (startDateControl) {
      startDateControl.valueChanges.subscribe((value:any) => {
        if (value) {
          const maxPublishDate = new Date(value);
          maxPublishDate.setDate(maxPublishDate.getDate() - 1);
          this.maxPub = maxPublishDate.toISOString().slice(0, 16);

          const minEndDate = new Date(value);
          minEndDate.setDate(minEndDate.getDate());
          this.minEnd = minEndDate.toISOString().slice(0, 16);
        }
      });
    }
    // this.maintenanceForm.get("start_date").valueChanges.subscribe((value) => {
    //   const maxPublishDate = new Date(value);
    //   maxPublishDate.setDate(maxPublishDate.getDate() - 1);
    //   this.maxPub = maxPublishDate.toISOString().slice(0, 16);

    //   const minEndDate = new Date(value);
    //   minEndDate.setDate(minEndDate.getDate());
    //   this.minEnd = minEndDate.toISOString().slice(0, 16);
    // });
  }
  updatecallibrationdata() {}

  getcalllibrationdata() {
    this.service
      .getData(`${this.middleware_url}mqtt/calibration/${this.MAC}`)
      .then(async (Res) => {
        let data = JSON.parse(
          JSON.parse(JSON.stringify(Res)).data.body.body[0].calibration_data
        );
        if (JSON.parse(JSON.stringify(Res)).data.body.body.length == 0) {
        } else {
          for (let i = 0; i < data.length; i++) {
            if (data[i].reading_number == 1) {
              this.callibrateform.get("rr1").setValue(data[i].radial);
              this.callibrateform.get("tr1").setValue(data[i].tangential);
              this.callibrateform.get("ar1").setValue(data[i].axial);
              // this.callibrateform = this.formBuilder.group({
              //   rr1: new FormControl(data[i].radial),
              //   tr1: new FormControl(data[i].tangential),
              //   ar1: new FormControl(data[i].axial),
              // });
            } else if (data[i].reading_number == 2) {
              this.callibrateform.get("rr2").setValue(data[i].radial);
              this.callibrateform.get("tr2").setValue(data[i].tangential);
              this.callibrateform.get("ar2").setValue(data[i].axial);
            } else if (data[i].reading_number == 3) {
              this.callibrateform.get("rr3").setValue(data[i].radial);
              this.callibrateform.get("tr3").setValue(data[i].tangential);
              this.callibrateform.get("ar3").setValue(data[i].axial);
            } else if (data[i].reading_number == 4) {
              this.callibrateform.get("rr4").setValue(data[i].radial);
              this.callibrateform.get("tr4").setValue(data[i].tangential);
              this.callibrateform.get("ar4").setValue(data[i].axial);
            } else if (data[i].reading_number == 5) {
              this.callibrateform.get("rr5").setValue(data[i].radial);
              this.callibrateform.get("tr5").setValue(data[i].tangential);
              this.callibrateform.get("ar5").setValue(data[i].axial);
            }
          }
        }
      })
      .catch((err) => {});
  }

  addBackgroundColor(min:any, max:any, color:any) {
    let Obj = {
      startValue: min,
      endValue: max,
      color: color,
    };
    return Obj;
  }
  batterystatusgraph(macadress:any) {
    this.service
      .getData(`${this.middleware_url}device/batterystatus/${macadress}`)
      .then(async (Res) => {
        // this.spinner.hide();
        this.batterystatus = JSON.parse(JSON.stringify(Res)).data.body.body;
        if (JSON.parse(JSON.stringify(Res)).data.status === "fail") {
          this.showPredAcousticsChartEmpty = true;
          this.chartLayoutOff = true;
        } else if (JSON.parse(JSON.stringify(Res)).data.status === "success") {
          this.chartLayoutOn = true;
          // this.showPredAcousticsChartEmpty = false;
          let lableW = "time";
          // this.absolutePercentageAcoustics = JSON.parse(
          //   JSON.stringify(Res)
          // ).data.body.absolute_percentage;
          // this.statusAcousticsPredictionValues = JSON.parse(
          //   JSON.stringify(Res)
          // ).data.body.status_for_prediction;
          if (this.statusAcousticsPredictionValues) {
            this.dataAcousticsPred1 = null;
          } else {
            this.dataAcousticsPred1 = JSON.parse(
              JSON.stringify(Res)
            ).data.body.body.map(function (val:any, index:any) {
              let arr1: any = val.x.split(/[- :]/);
              let time1A = new Date(
                arr1[0],
                arr1[1] - 1,
                arr1[2],
                arr1[3],
                arr1[4],
                arr1[5]
              );
              let x = time1A;
              let y = val.y;
              return { x, y };
            });
          }

          this.dataAcoustics1 = JSON.parse(
            JSON.stringify(Res)
          ).data.body.body.map(function (val:any, index:any) {
            let arr1: any = val.x.split(/[- :]/);
            let time1A = new Date(
              arr1[0],
              arr1[1] - 1,
              arr1[2],
              arr1[3],
              arr1[4],
              arr1[5]
            );
            let x = time1A;
            let y = val.y;
            return { x, y };
          });

          let self = this;
          this.listPreAcousticsChartData(
            this.dataAcoustics1,
            this.dataAcousticsPred1,
            [],
            [],
            [],
            []
          );

          if (document.getElementById("BatterystatusChart") !== null) {
            let predChartFour = cloneDeep(predicationChartObject);
            let feedDataToArray = [];
            feedDataToArray.push({
              data: this.dataAcoustics1.x,
              lineDashType: "",
              label: "time",
              legendMarkerType: "none",
            });
            feedDataToArray.push({
              data: this.dataAcousticsPred1,
              lineDashType: "dot",
              label: "status",
              legendMarkerType: "circle",
            });
            predChartFour.data = [];
            predChartFour.axisY.minimum = 0;
            predChartFour.axisY.maximum = 100;
            this.max_r = 20;
            this.max_y = 50;
            this.max_g = 100;

            predChartFour.unit = "%";
            predChartFour.myValue = this.statusAcousticsPredictionValues;
            predChartFour.type = "BAttery Status";
            predChartFour.data = this.makeDataForChart(feedDataToArray);

            this.batterystatuschart = new CanvasJS.Chart(
              "BatterystatusChart",
              predChartFour
            );
            this.batterystatuschart.render();

            this.batterystatuschart.axisY[0].addTo(
              "stripLines",
              this.addBackgroundColor(this.max_y, this.max_g, this.greenColor)
            );
            this.batterystatuschart.axisY[0].addTo("stripLines", {
              value: this.max_g,
              label: this.max_g,
              color: this.greenColor,
              labelFontColor: "#000000",
            });
            this.batterystatuschart.axisY[0].addTo(
              "stripLines",
              this.addBackgroundColor(this.max_r, this.max_y, this.yellowColor)
            );
            this.batterystatuschart.axisY[0].addTo("stripLines", {
              value: this.max_y,
              label: this.max_y,
              color: this.yellowColor,
              labelFontColor: "#000000",
            });
            this.batterystatuschart.axisY[0].addTo(
              "stripLines",
              this.addBackgroundColor(0, this.max_r, this.redColor)
            );
            this.batterystatuschart.axisY[0].addTo("stripLines", {
              value: this.max_r,
              label: this.max_r,
              color: this.redColor,
              labelFontColor: "#000000",
            });
          }
        } else {
          this.showPredAcousticsChartEmpty = true;
        }
      });
  }
  getTimeOnly(val) {
    let timeVal = new Date(val.x);
    timeVal.setMinutes(timeVal.getMinutes());
    let format1 = "YYYY-MM-DD HH:mm:ss";
    let addedDate = new Date(timeVal);
    let newDateBe = moment(addedDate).format(format1);
    let hours = timeVal.getHours();
    let minutes: any = timeVal.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = hours + ":" + minutes + " " + ampm;
    return newDateBe;
  }

  async listPreAcousticsChartData(
    data1,
    data2,
    data3,
    predData1,
    predData2,
    predData3
  ) {
    let self = this;
    var f_arr3;
    let f_arr = await Promise.all(
      data1.map(async function (f, fx) {
        let chartTime = self.getTimeOnly(f);
        return {
          d: chartTime,
          c1: f.y === null ? "" : f.y.toFixed(2),
          c2: "",
          c3: "",
        };
      })
    );
    if (data2 !== null) {
      let f_arr1 = await Promise.all(
        data2.map(async function (f, fx) {
          let chartTime = self.getTimeOnly(f);
          return {
            d: chartTime,
            c4: f.y === null ? "" : f.y.toFixed(2),
            c5: "",
            c6: "",
          };
        })
      );
      f_arr3 = [...f_arr, ...f_arr1];
    } else {
      f_arr3 = [...f_arr];
    }
    this.listPredAcousticsData1 = this.mergeArrayTemp(f_arr3, "d");
  }

  Startcallibration() {
    this.calibstop = false;
    let uuid = this.getRandom(10);

    //this.countcalib=1
    //Initial api call get call
    //while(this.countcalib<5){

    this.service.showwaitingfirst(
      "Calibraton is about to start ! First File is Being Processed"
    );
    this.askcallibrationfrombackend(uuid, this.countcalib);
    this.dialogReffstart = this.dialog.open(DialogPopupComponent, {
      width: "600px",
      height: "300px",
      maxWidth: "100%",
      data: {
        type: "MeassagepopupDialog",
        Message: "Waiting For the first file to process",
        timer: this.configtime,
      },
    });

    this.dialogReffstart.afterClosed().subscribe((result) => {
      if (result == "stop Callibration") {
        this.calibstop = true;
        this.spinner.hide();
        this.service
          .deleteInfo(
            this.base_middleware_url + `mqtt/calibration/${uuid}/${this.MAC}`
          )
          .then((res) => {
            if (JSON.parse(JSON.stringify(res)).data.status === "success") {
              this.service.showError("calibraton lapsed");
              this.countcalib = 1;
              this.calibstop = true;
              this.ngOnInit();
              this.alertDialogRef.close();
            } else {
              this.service.showSuccess("Error while deletion!");
            }
          });
      } else if (result == "timelapsed") {
        this.service
          .deleteInfo(
            this.base_middleware_url + `mqtt/calibration/${uuid}/${this.MAC}`
          )
          .then((res) => {
            if (JSON.parse(JSON.stringify(res)).data.status === "success") {
              this.service.showError("callibraton lapsed");
              this.countcalib = 1;
              this.calibstop = true;
              this.ngOnInit();
            } else {
              this.service.showSuccess("Error while deletion!");
            }
          });
      }
    });
  }

  async askcallibrationfrombackend(uuid, i) {
    //this.spinner.show();
    //this.MAC="E0693A042486"
    let mac_adress = this.MAC;
    // let mac_adress="E0693A0425CE"
    //for get request
    //need to create batch id
    //need to send mac_address

    if (this.countcalib < 6 && this.calibstop == false) {
      await this.service
        .getData(this.base_middleware_url + `mqtt/file/${mac_adress}/30`)
        .then(async (Res) => {
          if (JSON.parse(JSON.stringify(Res)).data.body.body.length == 0) {
            //wait for first file if not occur then wait for 30 sec
            setTimeout(() => {
              this.askcallibrationfrombackend(uuid, i);
            }, 30000);
          } else {
            this.spinner.hide();
            this.dialogReffstart.close("");
            if (this.countcalib > 1) {
              this.dialogReff.close("");
            }
            this.openDial(uuid, i, mac_adress, Res);
          }
        })
        .catch((err) => {
          console.log(err, "error in api fetching");
        });
    } else {
      this.spinner.hide();
      //this.getcalllibrationdata();
      // this.service.showSuccess('Callibraton  Done and values are saveddddd')
      // this.calibcompletemessage="callibration is completed! please close the window"

      this.countcalib = 1;
    }
  }

  async openDial(uuid, i, mac_adress, Res) {
    const dialogRef = this.dialog.open(AddcallibrationComponent, {
      width: "600px",
      maxWidth: "100%",
      data: {
        type: "DialogForManualReading",
        configtime: 2,
        number: i,
      },
    });
    dialogRef.afterClosed().subscribe(async (res) => {
      // received data from dialog-component
      this.countcalib++;
      if (res.message == "callibrationlapsed") {
        this.service.showError("callibraton lapsed");
        this.countcalib = 1;
        this.ngOnInit();
        this.calibstop = true;
        this.service
          .deleteInfo(
            this.base_middleware_url + `mqtt/calibration/${uuid}/${this.MAC}`
          )
          .then((res) => {
            if (JSON.parse(JSON.stringify(res)).data.status === "success") {
              // this.service.showError("callibraton lapseddddddddddeee")
              this.countcalib = 1;

              this.ngOnInit();
              this.alertDialogRef.close();
            } else {
              this.service.showSuccess("Error while deletion!");
            }
          });
      } else if (
        res.data.axial == null ||
        res.data.radial == null ||
        res.data.tangential == null
      ) {
        this.service
          .deleteInfo(
            this.base_middleware_url + `mqtt/calibration/${uuid}/${this.MAC}`
          )
          .then((res) => {
            if (JSON.parse(JSON.stringify(res)).data.status === "success") {
              this.service.showError("callibraton lapsed");
              this.countcalib = 1;
              this.ngOnInit();
              this.alertDialogRef.close();
            } else {
              this.service.showSuccess("Error while deletion!");
            }
          });
      } else {
        let body = {
          batch_id: uuid.toString(),
          mac_address: mac_adress.toString(),
          axial: res.data.axial,
          radial: res.data.radial,
          asset_id: this.assetID,
          device_id: this.deviceId,
          tangential: res.data.tangential,
          file_sent_time: Res.data.body.body[0].created_at,
          summary_file: JSON.parse(JSON.stringify(Res)).data.body.body[0]
            .summary_file,
          reading_number: i,
        };
        this.spinner.show();
        await this.service
          .postData(this.base_middleware_url + `mqtt/calibration`, body)
          .then((res) => {
            this.spinner.hide();

            this.service.showSuccess("Added successfully");
            this.getcalllibrationdata();
            //
            if (this.countcalib < 6) {
              if (JSON.parse(JSON.stringify(res)).data.status == "success") {
                //this.service.showwaiting('Now Waiting for the next value to process')
                //this.askcallibrationfrombackend(uuid,i);
                this.dialogReff = this.dialog.open(DialogPopupComponent, {
                  width: "300px",
                  maxWidth: "100%",
                  data: {
                    type: "MeassagepopupDialog",
                    Message: "Waiting For the next file to process",
                    timer: this.configtime,
                  },
                });
                setTimeout(() => {
                  this.askcallibrationfrombackend(uuid, i);
                }, 30000);

                this.dialogReff.afterClosed().subscribe((result) => {
                  //this.spinner.show();
                  if (result == "stop Callibration") {
                    this.service
                      .deleteInfo(
                        this.base_middleware_url +
                          `/mqtt/calibration/${uuid}/${this.MAC}`
                      )
                      .then((res) => {
                        if (
                          JSON.parse(JSON.stringify(res)).data.status ===
                          "success"
                        ) {
                          this.service.showError("callibraton lapsed");
                          this.countcalib = 1;
                          this.calibstop = true;
                          this.ngOnInit();
                          this.alertDialogRef.close();
                        } else {
                          this.service.showSuccess("Error while deletion!");
                        }
                      });
                  }
                });
                i++;
              } else {
              }
            } else {
              this.spinner.hide();
              this.getcalllibrationdata();
              this.service.showSuccess(
                "Calibration  Done and values are saved"
              );
              this.calibcompletemessage =
                "calibration is completed! please close the window";

              this.countcalib = 1;
            }

            //let result = JSON.parse(JSON.stringify(res));
          });
      }
      //for post request
      //{radial:1,tangential:1:axial:1}
      // reading_number
      //send summary file
      //batchid or uuid
    });
  }
  getRandom(length) {
    return Math.floor(
      Math.pow(10, length - 1) + Math.random() * 9 * Math.pow(10, length - 1)
    );
  }
  mergeArrayTemp(array, property) {
    const newArray = new Map();
    array.forEach((item) => {
      const propertyValue = item[property];
      newArray.has(propertyValue)
        ? newArray.set(propertyValue, {
            ...item,
            ...newArray.get(propertyValue),
          })
        : newArray.set(propertyValue, item);
    });

    return Array.from(newArray.values());
  }
  makeDataForChart(data) {
    let chartData = data.map(function (val, index) {
      let obj = {
        lineDashType: val.lineDashType,
        type: "line",
        legendMarkerType: val.legendMarkerType,
        xValueType: "dateTime",
        yValueFormatString: "",
        xValueFormatString: "hh:mm:ss TT",
        showInLegend: true,
        name: val.label,
        dataPoints: val.data,
      };
      return obj;
    });
    return chartData;
  }

  makeFFTDataForChart(data) {
    let chartData = data.map(function (val, index) {
      let obj = {
        type: "line",
        yValueFormatString: "",
        showInLegend: true,
        name: val.label,
        dataPoints: val.data,
      };
      return obj;
    });
    return chartData;
  }

  editAssets(assetsID, obj) {
    const payLoad = {
      assetID: assetsID,
      obj: obj,
      action: "edit",
    };
    this.dialogRef.close(payLoad);
  }

  viewAsset(id, idx, obj) {
    const payLoad = {
      id: id,
      idx: idx,
      obj: obj,
      action: "settings",
    };
    this.dialogRef.close(payLoad);
  }

  getDeviceInfo(id, idx, status, assets_id, view) {
    const payLoad = {
      id: id,
      idx: idx,
      status: status,
      assets_id: assets_id,
      view: view,
      action: "info",
    };
    this.dialogRef.close(payLoad);
  }

  serviceBookOpen(id, idx) {
    const payLoad = {
      id: id,
      idx: idx,
      action: "book",
    };
    this.dialogRef.close(payLoad);
  }

  alertSettings(assetId: Number, deviceId: Number) {}

  showDeleteDialog(id, inventory_id, index) {}

  validateNo(evt): any {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

  //get client's Asset Alert Settings code By deepak
  getClientLevelassetAlertSettings(clientID: any, assetId) {
    this.spinner.show();
    let settingsEmptyStatus = false;

    this.service
      .getData(`${this.alertBaseUrl}alert/settings/${assetId}/${clientID}`)
      .then(async (catRes) => {
        this.spinner.hide();
        this.alertCategory = JSON.parse(JSON.stringify(catRes)).data;
        for (let i = 0; i < this.alertCategory.length; i++) {
          for (let j = 0; j < this.alertCategory[i].type.length; j++) {
            if (this.alertCategory[i].type[j].settings.length === 0) {
              settingsEmptyStatus = true;
            } else {
              settingsEmptyStatus = false;
            }
          }
        }

      });
   console.log(this.alertCategory);
  }

  //get client's Alert Comment code By deepak
  getalertcommentbyid(device_raw_matric_id) {
    this.service
      .getData(
        `${this.alertBaseUrl}alert/comments/${
          Math.floor(Math.random() * 90 + 10).toString() +
          device_raw_matric_id.toString() +
          Math.floor(Math.random() * 9000 + 1000).toString()
        }`
      )
      .then(async (Res) => {
        this.spinner.hide();
        this.comments = JSON.parse(JSON.stringify(Res)).data.body.comments;
        if (this.comments.length > 0) {
          for (let i = 0; i <= this.comments.length; i++) {
            if (this.comments[i].time != undefined) {
              let testDateUtc = moment.utc(this.comments[i].time);
              let localDate = testDateUtc.local();
              let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(
                localDate
              );

              this.comments[i].time = timeUpdatedAt;
            }
          }
        } else {
          this.emptycommentmsg = "No Comments Has Been Logged yet";
        }
      });
  }
  changeAlertCategory(event) {
    this.AlertCategory = event.target.value;
  }
  changeAlertComment(event) {
    this.alertComment = event.target.value;
  }
  //post Alert Comment By Deepak
  onAddAlertClick() {
    let body: any = {};
    body.alert_comment = this.alertComment;
    body.alert_category = this.AlertCategory;
    body.alert_id =
      Math.floor(Math.random() * 90 + 10).toString() +
      this.device_raw_matric_id.toString() +
      Math.floor(Math.random() * 9000 + 1000).toString();
    body.asset_id = this.assetID;
    body.user_id = this.userid;
    this.spinner.show();

    if (
      body.alert_id != "" &&
      body.alert_category != "" &&
      body.alert_comment != "" &&
      body.user_id != "" &&
      body.asset_id != "" &&
      body.alert_id != undefined &&
      body.alert_category != undefined &&
      body.alert_comment != undefined &&
      body.user_id != undefined &&
      body.asset_id != undefined
    ) {
      this.service
        .postData(`${this.alertBaseUrl}alert/comments`, body)
        .then((res) => {
          this.spinner.hide();

          let result = JSON.parse(JSON.stringify(res));
          this.dialogRef.close("AlertBookOpen");
          this.service.showSuccess("Added successfully");
        });
    } else {
      this.service.showError("Please Add All the Values");
      this.spinner.hide();
    }
  }
  getClientLevelAlertSettings(clientID: any) {
    this.spinner.show();
    let settingsEmptyStatus = false;
    this.service
      .getData(`${this.alertBaseUrl}alert/main/settings/${clientID}`)
      .then(async (catRes) => {
        this.spinner.hide();
        this.alertCategory = JSON.parse(JSON.stringify(catRes)).data;
        for (let i = 0; i < this.alertCategory.length; i++) {
          for (let j = 0; j < this.alertCategory[i].type.length; j++) {
            if (this.alertCategory[i].type[j].settings.length === 0) {
              settingsEmptyStatus = true;
            } else {
              settingsEmptyStatus = false;
            }
          }
        }
        if (settingsEmptyStatus) {
          let payload = {
            client_id: clientID,
          };
          this.spinner.show();
          this.service
            .postData(
              `${this.alertBaseUrl}alert/settings/configurations/default`,
              payload
            )
            .then((res) => {
              this.spinner.hide();
              let result = JSON.parse(JSON.stringify(res));
              if (result.code != 200) {
                this.getClientLevelAlertSettings(clientID);
              }
            });
        }
      });
  }
  saveButtonEnabledAlertSettings = () => {
    const userColumns = this.disabledAlertSettingsColumn.user;
    const clientColumns = this.disabledAlertSettingsColumn.client;

    let isUserValid = false;
    let isClientValid = false;
    for (let key in userColumns) {
      if (userColumns[key] !== false) {
        isUserValid = true;
        break;
      }
    }
    for (let key in clientColumns) {
      if (clientColumns[key] !== false) {
        isClientValid = true;
        break;
      }
    }
      this.alertSaveButton = isUserValid && isClientValid;

    };
    updateDisabledColumns(): void {
      this.alertCategory.forEach((category) => {
        if (category.id === 2) {
          category.type.forEach((catType) => {
            catType.settings.forEach((setting) => {
              const isUser = setting.roleId === this.alertCategoryRoleIds.userId;
              const isClient = setting.roleId === this.alertCategoryRoleIds.clientAdminId;

              if (isUser) {
                if (catType.id === this.alertCategoryTypeIds.id1) {
                  const isEvent999 = parseInt(setting.event_counter) === 999;
                  this.disabledAlertSettingsColumn.user.event = isEvent999;
                  if (isEvent999 && this.disabledAlertSettingsColumn.user.time) {
                    this.disabledAlertSettingsColumn.user.event = false;
                    this.disabledAlertSettingsColumn.user.time = false;
                  }
                } else if (catType.id === this.alertCategoryTypeIds.id2) {
                  const isTime999 = parseInt(setting.event_counter) === 999;
                  this.disabledAlertSettingsColumn.user.time = isTime999;
                  if (isTime999 && this.disabledAlertSettingsColumn.user.event) {
                    this.disabledAlertSettingsColumn.user.event = false;
                    this.disabledAlertSettingsColumn.user.time = false;
                  }
                }
              }

              if (isClient) {
                if (catType.id === this.alertCategoryTypeIds.id1) {
                  const isEvent999 = parseInt(setting.event_counter) === 999;
                  this.disabledAlertSettingsColumn.client.event = isEvent999;
                  if (isEvent999 && this.disabledAlertSettingsColumn.client.time) {
                    this.disabledAlertSettingsColumn.client.event = false;
                    this.disabledAlertSettingsColumn.client.time = false;
                  }
                } else if (catType.id === this.alertCategoryTypeIds.id2) {
                  const isTime999 = parseInt(setting.event_counter) === 999;
                  this.disabledAlertSettingsColumn.client.time = isTime999;
                  if (isTime999 && this.disabledAlertSettingsColumn.client.event) {
                    this.disabledAlertSettingsColumn.client.event = false;
                    this.disabledAlertSettingsColumn.client.time = false;
                  }
                }
              }
            });
          });
        }
      });
    }

    manageAlertSettingsRow(roleId: any, typeID: any, value: any): void {
      if (this.initialLoadAlertSettings) {
        this.initialLoadAlertSettings = false;
      }
      const isUser = roleId === this.alertCategoryRoleIds.userId;
      const isClient = roleId === this.alertCategoryRoleIds.clientAdminId;
      if (isUser) {
        if (typeID === this.alertCategoryTypeIds.id1 || typeID === this.alertCategoryTypeIds.id2) {
          if (parseInt(value) === 999) {
            this.disabledAlertSettingsColumn.user.event = false;
            this.disabledAlertSettingsColumn.user.time = false;
          }
          else {
            if (typeID === this.alertCategoryTypeIds.id1) {
              this.disabledAlertSettingsColumn.user.event = false;
              this.disabledAlertSettingsColumn.user.time = true;
            } else if (typeID === this.alertCategoryTypeIds.id2) {
              this.disabledAlertSettingsColumn.user.time = false;
              this.disabledAlertSettingsColumn.user.event = true;
            }
          }
        }
      }
      if (isClient) {
        if (typeID === this.alertCategoryTypeIds.id1 || typeID === this.alertCategoryTypeIds.id2) {
          if (parseInt(value) === 999) {
            this.disabledAlertSettingsColumn.client.event = false;
            this.disabledAlertSettingsColumn.client.time = false;
          } else {
            if (typeID === this.alertCategoryTypeIds.id1) {
              this.disabledAlertSettingsColumn.client.event = false;
              this.disabledAlertSettingsColumn.client.time = true;
            } else if (typeID === this.alertCategoryTypeIds.id2) {
              this.disabledAlertSettingsColumn.client.time = false;
              this.disabledAlertSettingsColumn.client.event = true;
            }
          }
        }
      }
  }
  getAllAlertSettings(assetID: Number, clientID: Number, deviceID: Number) {
    this.spinner.show();
    let settingsEmptyStatus = false;
    this.initialLoadAlertSettings = true;
    this.service
      .getData(`${this.alertBaseUrl}alert/settings/${assetID}/${clientID}`)
      .then(async (catRes) => {
        this.spinner.hide();
        this.alertCategory = JSON.parse(JSON.stringify(catRes)).data;
        console.log(this.alertCategory);
        for (let i = 0; i < this.alertCategory.length; i++) {
          for (let j = 0; j < this.alertCategory[i].type.length; j++) {
            if (this.alertCategory[i].type[j].settings.length === 0) {
              this.alertCategory[i].type[j].settings
              // console.log(settingsEmptyStatus);
              settingsEmptyStatus = true;
              // console.log(settingsEmptyStatus);
            } else {
              settingsEmptyStatus = false;
            }
            if(i === 1) {
              this.alertCategoryRoleIds.userId = this.alertCategory[i].type[j].settings[0].roleId;
              this.alertCategoryRoleIds.clientAdminId = this.alertCategory[i].type[j].settings[1].roleId;
              if(j === 0) this.alertCategoryTypeIds.id1 = this.alertCategory[i].type[j].id;
              else if(j === 1) this.alertCategoryTypeIds.id2 = this.alertCategory[i].type[j].id;
            }
          }
        }
        this.updateDisabledColumns();
        // if (settingsEmptyStatus) {
        //   let payload = {
        //     asset_id: assetID,
        //     client_id: clientID,
        //     device_id: deviceID,
        //   };
        //   this.spinner.show();
        //   this.service
        //     .postData(`${this.alertBaseUrl}alert/settings/default`, payload)
        //     .then((res) => {
        //       this.spinner.hide();
        //       let result = JSON.parse(JSON.stringify(res));
        //       if (result.code === 200) {
        //         this.getAllAlertSettings(assetID, clientID, deviceID);
        //       }
        //     });
        // }
      });
  }

  camalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  getAssetOnOffStatus(inventoryID) {
    this.service
      .getData(this.getInventoryByIDUrl + "/" + inventoryID)
      .then((res) => {
        let resp = JSON.parse(JSON.stringify(res))[0];
        // this.subscribeNewTopic(resp.mac_address);
        this.service
          .getData(this.deviceStatusURL + "device/status/" + resp.mac_address)
          .then((devSRes) => {
            let deviceRes = JSON.parse(JSON.stringify(devSRes)).data.body;
            if (deviceRes != null) {
              // this.onoffStatus = deviceRes.asset_status;
              this.onoffStatus = 1;
            }
          });
      });
  }

  deleteVersion(tabType) {
    if (tabType) {
      if (this.selectedInventoryArr.length === 0) {
        this.service.showError("No items selected!");
      } else {
        this.service
          .deleteData(
            this.deleteFWVersion +
              "/delete/version?ids=" +
              this.selectedInventoryArr,
            {}
          )
          .then((res) => {
            if (
              JSON.parse(JSON.stringify(res)).body.data.status === "success"
            ) {
              this.service.showSuccess(
                JSON.parse(JSON.stringify(res)).body.data.message
              );
              this.dialogRef.close("DeletionCompleted");
              this.selectedInventoryArr = [];
            } else {
              this.service.showSuccess("Error while deletion!");
            }
          });
      }
    } else {
      if (this.selectedInventoryArr.length === 0) {
        this.service.showError("No items selected!");
      } else {
        this.service
          .deleteData(
            this.deleteFWVersion +
              "/delete/wifi/version?ids=" +
              this.selectedInventoryArr,
            {}
          )
          .then((res) => {
            if (
              JSON.parse(JSON.stringify(res)).body.data.status === "success"
            ) {
              this.service.showSuccess(
                JSON.parse(JSON.stringify(res)).body.data.message
              );
              this.dialogRef.close("WifiDeletionCompleted");
              this.selectedInventoryArr = [];
            } else {
              this.service.showSuccess("Error while deletion!");
            }
          });
      }
    }
  }
  getHealthIndies(assetid) {
    //this.userForm.get('name').setValue('Mahesh');
    //this.HealthindicesForm.controls["Mechanical_Health"].disable();

    let endpoint =
      this.base_middleware_url +
      "machine/indices/" +
      assetid +
      "/" +
      localStorage.getItem("mac_address");
    this.service.gethealthindicesbyassetid(endpoint).then((res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        //this.service.showSuccess(JSON.parse(JSON.stringify(res)).body.data.message);
        //this.dialogRef.close("Update Weightage");
        //this.selectedInventoryArr = [];
        if (JSON.parse(JSON.stringify(res)).data.body.length != 0) {
          this.unchangedValueArr = JSON.parse(JSON.stringify(res)).data.body;
          this.HealthindicesForm.get("Mechanical_Health").setValue(
            JSON.parse(JSON.stringify(res)).data.body[0].mechanical_health
          );
          this.HealthindicesForm.get("Thermal_Health").setValue(
            JSON.parse(JSON.stringify(res)).data.body[0].thermal_health
          );
          this.HealthindicesForm.get("Electrical_Health").setValue(
            JSON.parse(JSON.stringify(res)).data.body[0].electrical_health
          );
          this.HealthindicesForm.get("Bearings_Health").setValue(
            JSON.parse(JSON.stringify(res)).data.body[0].bearing_health
          );
        } else {
          this.HealthindicesForm.get("Mechanical_Health").setValue(25);
          this.HealthindicesForm.get("Thermal_Health").setValue(25);
          this.HealthindicesForm.get("Electrical_Health").setValue(25);
          this.HealthindicesForm.get("Bearings_Health").setValue(25);
        }

        //Form Value to be set here
      } else {
        this.service.showError("Error while Updati");
      }
    });
  }

  getDirtyValues(form: any) {
    let dirtyValues = {};
    Object.keys(form.controls).forEach((key) => {
      let currentControl = form.controls[key];
      if (currentControl.dirty) {
        if (currentControl.controls)
          dirtyValues[key] = this.getDirtyValues(currentControl);
        else dirtyValues[key] = currentControl.value;
      }
    });
    return dirtyValues;
  }

  isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  UpdateHealthIndices() {
    let mh = this.HealthindicesForm.get("Mechanical_Health").value;
    let th = this.HealthindicesForm.get("Thermal_Health").value;
    let eh = this.HealthindicesForm.get("Electrical_Health").value;
    let bh = this.HealthindicesForm.get("Bearings_Health").value;

    if (
      this.HealthindicesForm.get("Mechanical_Health").value +
        this.HealthindicesForm.get("Thermal_Health").value +
        this.HealthindicesForm.get("Electrical_Health").value +
        this.HealthindicesForm.get("Bearings_Health").value >
        100 ||
      this.HealthindicesForm.get("Mechanical_Health").value +
        this.HealthindicesForm.get("Thermal_Health").value +
        this.HealthindicesForm.get("Electrical_Health").value +
        this.HealthindicesForm.get("Bearings_Health").value <
        100
    ) {
      this.service.showError("Sum of the parameters should be 100 %");
    } else {
      let ubody = {
        mechanical_health: mh,
        thermal_health: th,
        electrical_health: eh,
        bearing_health: bh,
      };

      let endpoint =
        this.base_middleware_url +
        "machine/indices/" +
        this.assetID +
        "/" +
        localStorage.getItem("mac_address");

      this.service.putData(endpoint, ubody).then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status == "success") {
          this.service.showSuccess("Health Indices updated Succesfully");
          let body = this.getDirtyValues(this.HealthindicesForm);
          if (!this.isEmpty(this.getDirtyValues(this.HealthindicesForm))) {
            let body = this.getDirtyValues(this.HealthindicesForm);
            this.auditTrail(body, 4);
          }
          this.dialogRef.close("Update Weightage");
        } else {
          this.service.showError("Error while Updating");
        }
      });
    }
  }
  uploadWifiVersion(files: any) {
    if (this.wifi_device_version === "") {
      this.service.showError("Wifi version can't be empty!");
    } else {
      this.data.inventoryData.upgrade_url = files[0].name;
      this.fileName = files[0].name;
      this.wifiVersionUploader.uploadAll();
      this.wifiVersionUploader.onProgressItem = (progress: any) => {
        this.percentDone = progress["progress"];
      };
    }
  }

  checkUncheckAll(e) {
    if (e.target.checked) {
      for (var i = 0; i < this.versionsList.length; i++) {
        this.versionsList[i].isSelected = true;
        this.selectedInventoryArr.push(this.versionsList[i].id);
      }
    } else {
      for (var i = 0; i < this.versionsList.length; i++) {
        this.versionsList[i].isSelected = false;
      }
      this.selectedInventoryArr = [];
    }
  }

  onCheckboxChange(e) {
    if (e.target.checked) {
      this.selectedInventoryArr.push(JSON.parse(e.target.value));
    } else {
      const index = this.selectedInventoryArr.indexOf(
        JSON.parse(e.target.value)
      );
      if (index > -1) {
        this.selectedInventoryArr.splice(index, 1);
      }
    }
  }
  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || "").trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }
  ngOnInit() {
    this.maintenanceForm = this.fb.group({
      startDate: [null, Validators.required],
      // ... other controls
    });
    // this.maintenanceForm.get("start_date").valueChanges.subscribe(() => {
    //   console.log("START DATE CHANGED");
    //   console.log(this.maintenanceForm.value);
    //   this.setPublish(); // Update maxPublish when start_date changes
    // });


    this.alertSaveButton = true;
    this.inventoryForm = this.formBuilder.group({
      device_Serial: ["", [Validators.required, this.noWhitespaceValidator]],
      mac_add: ["", [Validators.required, this.noWhitespaceValidator]],
      gateway_url: [""],
      exampleFormControlSelect1: [""]
    });

    if(this.dialog_type === "editNewInventoryDIALOG" && this.data.inventoryData.isClientAssociated) {
      this.inventoryForm.get('exampleFormControlSelect1')?.disable();
    }
    if(this.dialog_type === "editNewInventoryDIALOG" && this.data.inventoryData.master_type==4) {
        this.inventoryForm.get('mac_add').disable();
    }
    this.uploader.onBuildItemForm = (item, form) => {
      form.append("token", localStorage.getItem("token"));
      form.append("fw_version", this.device_version);
    };
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      if (JSON.parse(response).data.status === "error") {
        this.service.showError(JSON.parse(response).data.body);
      } else {
        this.service.showSuccess("successfully saveddd!");
      }
    };

    // this.maintenanceForm = this.formBuilder.group({
    //       title_val: new FormControl("", [Validators.required]),
    //       description: new FormControl(""),
    //       start_date: new FormControl("",[Validators.required]),
    //       end_date: new FormControl("", [Validators.required]),
    //       publish_date: new FormControl("", [Validators.required])
    //     });
    this.wifiVersionUploader.onBuildItemForm = (item, form) => {
      form.append("token", localStorage.getItem("token"));
      form.append("wifi_version", this.wifi_device_version);
    };
    this.wifiVersionUploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.wifiVersionUploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      if (JSON.parse(response).data.status === "error") {
        this.service.showError(JSON.parse(response).data.body);
      } else {
        this.service.showSuccess("successfully saved!");
      }
    };

    if (this._client_asset_id != undefined) {
      this.getSensorGroupByID();
    }
    this.subscribeToStartDateChanges();
    if(this.data.type == 'addNewInvenDeviceDialogBox' || this.data.type ==  'editNewInventoryDIALOG')
    this.fetchMasterProducts()

  }
upload(files: FileList) {
  try {
    if (!files || files.length === 0) {
      this.service.showError("Please select a file.");
      return;
    }

    if (!this.device_version) {
      this.service.showError("FW version can't be empty!");
      return;
    }

    this.fileName = files[0].name;
    this.data.inventoryData.upgrade_url = this.fileName;

    this.uploader.clearQueue();
    this.uploader.addToQueue(Array.from(files)); // ✅ Fixed here
    this.uploader.uploadAll();
  } catch (err) {
    console.error("Upload error:", err);
  }
}



  download() {
    let csvAr = [];
    let csvOptions = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalseparator: ".",
      showLabels: true,
      showTitle: true,
      title: "Plant Report",
      useBom: true,
      noDownload: false,
      headers: [
        "Site",
        "Application",
        "Asset",
        "Make",
        "Latest Status",
        "Diagnosed Issue",
        "% Full Load",
        "Average Stops",
        "Run-time",
        "Last Service Date",
        "Service Performed",
      ],
    };

    this.plantDATA.map(function (val, index) {
      let makeObj = {
        site: val.site,
        application: val.application,
        asset: val.asset,
        make: val.make,
        status: val.status,
        diagnosed_issue: val.diagnosed_issue,
        full_load: val.full_load,
        stops: val.stops,
        run_time: val.run_time,
        last_service: val.last_service,
        service_performed: val.service_performed,
      };
      csvAr.push(makeObj);
    });
    new AngularCsv(csvAr, "Plant Report", csvOptions);
  }

  selectItem(value) {
    localStorage.setItem("plantIntervalType", value);
    switch (value) {
      case "day":
        this.valueSelectedFor = "day";
        this.tabColor1 = "active";
        this.tabColor2 = "";
        this.tabColor3 = "";
        this.tabColor4 = "";
        this.tabColor5 = "";
        break;
      case "week":
        this.valueSelectedFor = "week";
        this.tabColor1 = "";
        this.tabColor2 = "active";
        this.tabColor3 = "";
        this.tabColor4 = "";
        this.tabColor5 = "";
        break;
      case "month":
        this.valueSelectedFor = "month";
        this.tabColor1 = "";
        this.tabColor2 = "";
        this.tabColor3 = "active";
        this.tabColor4 = "";
        this.tabColor5 = "";
        break;
      case "quarterly":
        this.valueSelectedFor = "quarter";
        this.tabColor1 = "";
        this.tabColor2 = "";
        this.tabColor3 = "";
        this.tabColor4 = "active";
        this.tabColor5 = "";
        break;
      case "Yearly":
        this.valueSelectedFor = "year";
        this.tabColor1 = "";
        this.tabColor2 = "";
        this.tabColor3 = "";
        this.tabColor4 = "";
        this.tabColor5 = "active";
        break;
    }
    this.viewPlantDialogBox1();
  }

  viewPlantDialogBox1() {
    this.service
      .getData(
        this.plantInfoUrl +
          "/" +
          localStorage.getItem("user_id") +
          "?filter=" +
          this.valueSelectedFor
      )
      .then(async (res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (JSON.parse(JSON.stringify(res)).data.body.length === 0) {
            this.service.showSuccess("No Assets Available!");
          } else {
            this.plantDATA = JSON.parse(JSON.stringify(res)).data.body;
            for (let i = 0; i < this.plantDATA.length; i++) {
              this.plantDATA[i].last_service =
                new ConvertDatetimePipe().convertDateTime(
                  moment.utc(this.plantDATA[i].last_service).local()
                );
            }
          }
        }
      });
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  checkSelectedValue(valCh) {
    if (valCh.checked) {
      this.typeArray.push(valCh.value);
    } else {
      this.removeElement(this.typeArray, valCh.value);
    }
  }

  removeElement(array, elem) {
    var index = array.indexOf(elem);
    if (index > -1) {
      array.splice(index, 1);
    }
  }

  clientLicenceSel() {
    this.dialogRef.close(this.typeArray);
  }

  selectDeviceType(sValue) {
    let e = <HTMLSelectElement>document.getElementById(sValue);
    let selectedValueGN = e.options[e.selectedIndex].value;
    this.service.getDataWithQuery(this.getLicenseURL).then((res) => {
      const result = JSON.parse(JSON.stringify(res));
      if (result.data.status === "success") {
        if (result.data.body.length !== 0) {
          this.selectedValueMoter = result.data.body.find(
            (item) =>
              parseInt(item.device_type_id) === parseInt(selectedValueGN)
          );
          this.quantityPreValue = this.selectedValueMoter;
        }
      } else {
        this.service.showError("Something went wrong.");
      }
    });
  }

  changeModel(ev, checkedName) {
    if (ev.target.checked) {
      this.listNamesChecked.push(checkedName);
      this.data.data.last_service_performed = this.listNamesChecked.join();
    } else {
      let i = this.listNamesChecked.indexOf(checkedName);
      this.listNamesChecked.splice(i, 1);
      this.data.data.last_service_performed = this.listNamesChecked.join();
    }
  }

  changeModelForOther(ev, checkedName) {
    if (ev.target.checked) {
      this.showOther = true;
    } else {
      this.showOther = false;
    }
  }

  addNewServiceType() {
    this.listNamesChecked.push(this.newServiceType);
    this.data.data.last_service_performed = this.listNamesChecked.join();
    this.newServiceType = "";
  }

  removeServiceType() {
    this.data.data.last_service_performed = "";
  }

  chageServiceCategory(ev) {
    this.serviceCategory = ev.target.value;
    this.data.data.service_category = this.serviceCategory;
  }

  closeDropdown() {
    this.shouldShow = false;
  }

  dropdownOpen(val) {
    if (val === "dropdown") {
      this.shouldShow = !this.shouldShow;
    }
  }

  async addDeviceType(el) {
    let e = <HTMLSelectElement>document.getElementById(el);
    let selectedValue = e.options[e.selectedIndex].value;
    let selectedTitle = e.options[e.selectedIndex].text;
    let quantity = parseFloat(
      (<HTMLInputElement>document.getElementById("qu")).value
    );

    this.nbody = {
      user_id: localStorage.getItem("user_id"),
      device_type_id: selectedValue,
      device_type: selectedTitle,
      quantity: quantity,
      used: 0,
    };
    this.service.postData(this.createLicenceUrl + "/company", this.nbody).then(
      await ((res) => {
        this.changeService.loader(false);
        const result = JSON.parse(JSON.stringify(res));
        if (result.data.status === "success") {
          this.dialogRef.close();
        } else {
          this.service.showError("Something went wrong.");
        }
      })
    );
  }

  getSensorGroupByID() {
    const myArrayValue = [
      {
        user_id: parseInt(this._clientAId),
        asset_id: parseInt(this._client_asset_id),
        metric_type: "kwrating1",
        base_value: 0,
        max_value: 10,
        threshold_1: 1.8,
        threshold_2: 4.5,
        threshold_3: 10,
      },
      {
        user_id: parseInt(this._clientAId),
        asset_id: parseInt(this._client_asset_id),
        metric_type: "kwrating2",
        base_value: 0,
        max_value: 11,
        threshold_1: 2.8,
        threshold_2: 7.1,
        threshold_3: 11,
      },
      {
        user_id: parseInt(this._clientAId),
        asset_id: parseInt(this._client_asset_id),
        metric_type: "kwrating3",
        base_value: 0,
        max_value: 15,
        threshold_1: 4.5,
        threshold_2: 11.2,
        threshold_3: 15,
      },
    ];
    const body = {
      user_id:
        Math.floor(Math.random() * 90 + 10) +
        this._clientAId +
        Math.floor(Math.random() * 9000 + 1000),
      asset_id: parseInt(this._client_asset_id),
    };
    this.uForm = this.formBuilder.group({});
    this.changeService.loader(true);
    this.service.postData(this.assetMatricsUrl, body).then((res) => {
      this.changeService.loader(false);
      let resp = JSON.parse(JSON.stringify(res)).data;
      if (resp.status === "fail") {
        const msgErr = resp.body.message;
        this.service.showError(msgErr);
      } else if (resp.status === "success") {
        if (this.assetType === "GEAR") {
          let acceleration = resp.body.filter((item) => {
            return item.metric_type === "acceleration";
          });
          this._sensorGroupData.push(acceleration[0]);
          this.fftBaseValue = acceleration[0].fft_base;
          let temperature = resp.body.filter((item) => {
            return item.metric_type === "temperature";
          });
          this._sensorGroupData.push(temperature[0]);
          let sound = resp.body.filter((item) => {
            return item.metric_type === "sound";
          });
          let audible = resp.body.filter((item) => {
            return item.metric_type === "audible";
          });
          if (audible.length != 0) this._sensorGroupData.push(audible[0]);
          else {
            this._sensorGroupData.push({
              user_id: parseInt(this._clientAId),
              asset_id: parseInt(this._client_asset_id),
              metric_type: "Audible",
              base_value: 0,
              max_value: 100,
              threshold_1: 75,
              threshold_2: 100,
              threshold_3: 125,
            });
          }
          if (sound.length != 0) {
            this._sensorGroupData.push(sound[0]);
          } else {
            this._sensorGroupData.push({
              user_id: parseInt(this._clientAId),
              asset_id: parseInt(this._client_asset_id),
              metric_type: "sound",
              base_value: 0,
              max_value: 32,
              threshold_1: 25,
              threshold_2: 50,
              threshold_3: 125,
            });
          }
          let kwrating3 = resp.body.filter((item) => {
            return item.metric_type === "kwrating3";
          });
          if (kwrating3 === undefined) {
            this.sensorKWpowerGroupData.push(myArrayValue[2]);
          } else {
            this.sensorKWpowerGroupData.push(kwrating3[0]);
          }
        } else {
          let acceleration = resp.body.filter((item) => {
            return item.metric_type === "acceleration";
          });
          this._sensorGroupData.push(acceleration[0]);
          this.fftBaseValue = acceleration[0].fft_base;
          let temperature = resp.body.filter((item) => {
            return item.metric_type === "temperature";
          });
          this._sensorGroupData.push(temperature[0]);
          let sound = resp.body.filter((item) => {
            return item.metric_type === "sound";
          });
          let audible = resp.body.filter((item) => {
            return item.metric_type === "audible";
          });
          // this.kurt_anomaly_counter =
          //   this._sensorGroupData[0].kurt_anomaly_counter;
          // this.kurt_freq = this._sensorGroupData[0].kurt_freq;
          // this.kurt_threshold = this._sensorGroupData[0].kurt_threshold;
          // console.log("------------------------------------------------");
          // console.log(
          //   this.kurt_anomaly_counter,
          //   this.kurt_freq,
          //   this.kurt_threshold
          // );
          this._sensorGroupData.push(audible[0]);
          if (sound.length != 0) {
            this._sensorGroupData.push(sound[0]);
          } else {
            this._sensorGroupData.push({
              user_id: parseInt(this._clientAId),
              asset_id: parseInt(this._client_asset_id),
              metric_type: "sound",
              base_value: 0,
              max_value: 32,
              threshold_1: 25,
              threshold_2: 50,
              threshold_3: 125,
            });
          }
          let kwrating1 = resp.body.filter((item) => {
            return item.metric_type === "kwrating1";
          });
          if (kwrating1 === undefined) {
            this.sensorKWpowerGroupData.push(myArrayValue[0]);
          } else {
            this.sensorKWpowerGroupData.push(kwrating1[0]);
          }
          let kwrating2 = resp.body.filter((item) => {
            return item.metric_type === "kwrating2";
          });
          if (kwrating2 === undefined) {
            this.sensorKWpowerGroupData.push(myArrayValue[1]);
          } else {
            this.sensorKWpowerGroupData.push(kwrating2[0]);
          }
          let kwrating3 = resp.body.filter((item) => {
            return item.metric_type === "kwrating3";
          });
          if (kwrating3 === undefined) {
            this.sensorKWpowerGroupData.push(myArrayValue[2]);
          } else {
            this.sensorKWpowerGroupData.push(kwrating3[0]);
          }
        }

        this.tempMainMatricsValue = this._sensorGroupData;
      } else {
        this.service.showError("Something went wrong.");
      }
    });
  }

  search(term: string, i): void {
    let myval = parseFloat(
      (<HTMLInputElement>document.getElementById("max_value_" + i)).value
    );
    let titleValue = document.getElementById("title_value_" + i).innerText;
    for (var a = 0; a < this._sensorGroupData.length; a++) {
      if (titleValue === this._sensorGroupData[a].metric_type) {
        if (this._sensorGroupData[a + 1] !== undefined) {
          this._sensorGroupData[a + 1].base_value = myval;
        }
      }
    }
  }

  searchSecond(val, i) {
    let titleValue = document.getElementById("title_value_" + i).innerText;
    let myval1 = parseFloat(
      (<HTMLInputElement>document.getElementById("threshold_2_" + i)).value
    );
    for (var a = 0; a < this._sensorGroupData.length; a++) {
      if (titleValue === this._sensorGroupData[a].metric_type) {
        if (this._sensorGroupData[a] !== undefined) {
          this._sensorGroupData[a].threshold_3 = myval1;
        }
      }
    }
  }

  onChangeFFTBaseValue() {
    let body = {
      fft_base: this.fftBaseValue,
    };
    this.service
      .putData(
        this.assetMatricsUrl + "/" + "fftbase/update/" + this._client_asset_id,
        body
      )
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
        } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        } else {
        }
      });
  }
  checkThresholdCorrectness(current_value){
    if(current_value.metric_type.startsWith('kw')) return
    let {threshold_1,threshold_2,threshold_3,metric_type}=current_value
    if(threshold_1>=threshold_2 || threshold_1>=threshold_3){
      this.service.showError(metric_type=='sound'?'Delta ultrasound'+"'s green value should be less than yellow":metric_type+"'s green value should be less than yellow")
      this.correctMetricValues[metric_type]=false
    }else if(threshold_2>=threshold_3){
      this.service.showError(metric_type=='sound'?'Delta ultrasound'+"'s yellow value should be less than red":metric_type+"'s yellow value should be less than red")
      this.correctMetricValues[metric_type]=false
    }else{
      this.correctMetricValues[metric_type]=true
    }
  }


  saveSensorSettings() {
    let self = this;
    let sensorSettingsArr = [];
    let changedValues = {};
    /**
     * Pushed sensor group values in sensorSettingsArr
     * */
    // console.log(this._sensorGroupData);
    this._sensorGroupData.map(function (val, index) {
      let sgBody = {
        id: val.id,
        metric_type: val.metric_type,
        user_id: parseInt(self._clientAId),
        asset_id: parseInt(self._client_asset_id),
        inventory_id: self.inventoryID,
        base_value:
          document.getElementById("base_value_" + index) === null
            ? 0
            : parseFloat(
                (<HTMLInputElement>(
                  document.getElementById("base_value_" + index)
                )).value
              ),
        max_value: parseFloat(
          (<HTMLInputElement>document.getElementById("max_value_" + index))
            .value
        ),
        threshold_1: parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_1_" + index))
            .value
        ),
        threshold_2: parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_2_" + index))
            .value
        ),
        threshold_3: parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_3_" + index))
            .value
        ),
      };
      if (
        (val.base_value != document.getElementById("base_value_" + index)) ===
        null
          ? 0
          : parseFloat(
              (<HTMLInputElement>document.getElementById("base_value_" + index))
                .value
            )
      ) {
        changedValues["base_value"] =
          document.getElementById("base_value_" + index) === null
            ? 0
            : parseFloat(
                (<HTMLInputElement>(
                  document.getElementById("base_value_" + index)
                )).value
              );
      }
      if (
        val.max_value !=
        parseFloat(
          (<HTMLInputElement>document.getElementById("max_value_" + index))
            .value
        )
      ) {
        changedValues["max_value"] = parseFloat(
          (<HTMLInputElement>document.getElementById("max_value_" + index))
            .value
        );
      }
      if (
        val.threshold_1 !=
        parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_1_" + index))
            .value
        )
      ) {
        changedValues["threshold_1"] = parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_1_" + index))
            .value
        );
      }
      if (
        val.threshold_2 !=
        parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_2_" + index))
            .value
        )
      ) {
        changedValues["threshold_2"] = parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_2_" + index))
            .value
        );
      }
      if (
        val.threshold_3 !=
        parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_3_" + index))
            .value
        )
      ) {
        changedValues["threshold_3"] = parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_3_" + index))
            .value
        );
      }
      sensorSettingsArr.push(sgBody);
      return;
    });

    this._sensorGroupData.map((val, index) => {
      this.unchangedValueArr[index] = this._sensorGroupData[index];
    });

    /**
     * Pushed velocity threshold values in sensorSettingsArr
     * */
    /**
     * Pushed velocity threshold values in sensorSettingsArr
     * */
    this.sensorKWpowerGroupData.map(function (val, index) {
      let sgkbody = {
        id: val.id,
        metric_type: val.metric_type,
        user_id: parseInt(self._clientAId),
        asset_id: parseInt(self._client_asset_id),
        inventory_id: self.inventoryID,
        base_value: parseFloat(
          (<HTMLInputElement>(
            document.getElementById("base_value_1_dev" + index)
          )).value
        ),
        max_value: parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_3_dev" + index))
            .value
        ),
        threshold_1: parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_1_dev" + index))
            .value
        ),
        threshold_2: parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_2_dev" + index))
            .value
        ),
        threshold_3: parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_3_dev" + index))
            .value
        ),
      };

      if (
        val.base_value !=
        parseFloat(
          (<HTMLInputElement>(
            document.getElementById("base_value_1_dev" + index)
          )).value
        )
      ) {
        changedValues["velocity_base_value"] = parseFloat(
          (<HTMLInputElement>(
            document.getElementById("base_value_1_dev" + index)
          )).value
        );
      }
      if (
        val.max_value !=
        parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_3_dev" + index))
            .value
        )
      ) {
        changedValues["velocity_max_value"] = parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_3_dev" + index))
            .value
        );
      }
      if (
        val.threshold_1 !=
        parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_1_dev" + index))
            .value
        )
      ) {
        changedValues["velocity_threshold_1"] = parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_1_dev" + index))
            .value
        );
      }
      if (
        val.threshold_2 !=
        parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_2_dev" + index))
            .value
        )
      ) {
        changedValues["velocity_threshold_2"] = parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_2_dev" + index))
            .value
        );
      }
      if (
        val.threshold_3 !=
        parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_3_dev" + index))
            .value
        )
      ) {
        changedValues["velocity_threshold_3"] = parseFloat(
          (<HTMLInputElement>document.getElementById("threshold_3_dev" + index))
            .value
        );
      }
      sensorSettingsArr.push(sgkbody);
      return;
    });
    let i = 2;
    this.sensorKWpowerGroupData.map((val, index) => {
      i++;
      this.unchangedValueArr[i] = this.sensorKWpowerGroupData[index];
    });
    console.log("KW POWER GROUP DATA")
    console.log(this.sensorKWpowerGroupData)
    console.log(this.unchangedValueArr)
    self.auditTrail(sensorSettingsArr, 0);
    if(!this.showKurtosis){
      let threshold=parseFloat(
        (<HTMLInputElement>document.getElementById("kurt_threshold")).value
      )
      let kurt_freq=Number(
        (<HTMLInputElement>document.getElementById("kurt_frequency")).value
      )
      let kurt_anomaly_counter=Number(
        (<HTMLInputElement>document.getElementById("kurt_anomaly_counter")).value
      )
      // if(kurt_anomaly_counter)
      if (
        threshold > 4 || threshold <1
      ) {
        self.service.showError("Threshold should be between 1 and 4");
        return;
      }
      // if (
      //   kurt_freq > 8 || kurt_freq <6
      // ) {
      //       self.service.showError("Frequency should be between 6 and 8");
      //       return;
      // }
      if(kurt_freq%1 !==0){
        self.service.showError("Frequency should be an integer");
        return;
      }
      if (
        (kurt_anomaly_counter > 7 ||  kurt_anomaly_counter < 0)
      ) {
        self.service.showError("Anomaly Counter should be between 0 and 7");
        return;
      }
      if( kurt_anomaly_counter%1 !==0){
        self.service.showError("Anomaly Counter should be an integer");
        return;
      }

      let kurtosisData = {
        kurt_freq: Number(
          (<HTMLInputElement>document.getElementById("kurt_frequency")).value
        ),
        kurt_threshold: Number(
          (<HTMLInputElement>document.getElementById("kurt_threshold")).value
        ),
        kurt_anomaly_counter: Number(
          (<HTMLInputElement>document.getElementById("kurt_anomaly_counter"))
            .value
        ),
        asset_id: self._client_asset_id,
        user_id: self._clientAId,
        index_ref: 10,
        id: "test_id", //id not required for kurtosis
      };
      localStorage.setItem("kurt_threshold",String(kurtosisData.kurt_threshold))
      localStorage.setItem("kurt_anomaly_counter",String(kurtosisData.kurt_anomaly_counter))
      localStorage.setItem("kurt_freq",String(kurtosisData.kurt_freq))
      self.service
      .putData(self.assetMatricsUrl + "/" + kurtosisData.id, kurtosisData)
      .then((res) => {
        self.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          self.service.showError(msgErr);
          self.dialogRef.close();
        } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          // self.service.showSuccess("Updated Succefully");
          self.dialogRef.close({isChanged:true,graphToReload});
        }
      });
    }

    /**
     * Saveing sensor settings from sensorSettingsArr
     * */
    let graphToReload={};
    if (sensorSettingsArr.length !== 0) {
      sensorSettingsArr.map(function (val, index) {
        self.checkThresholdCorrectness(val)
        let isChanged=self.compareSensorChanges(val,self._sensorGroupData,self.sensorKWpowerGroupData)
        if(!isChanged) return;
        else graphToReload[val.metric_type]=true;
        console.log(graphToReload)
        val["index_ref"] = index;

        self.service
          .putData(self.assetMatricsUrl + "/" + val.id, val)
          .then((res) => {
            self.changeService.loader(false);
            if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
              const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
              self.service.showError(msgErr);
              self.dialogRef.close({});
            } else if (
              JSON.parse(JSON.stringify(res)).data.status === "success"
            ) {
              if (
                self.assetType === "MOTOR" ||
                self.assetType === "FAN_BLOWER" ||
                self.assetType === "PUMP" ||
                self.assetType === "COMPRESSOR" ||
                self.assetType === "JOURNAL_BEARING"
              ) {
                if (index === sensorSettingsArr.length - 1) {
                  if (Object.keys(changedValues).length != 0) {
                    //console.log(changedValueArr,'changesvalues')
                    //self.auditTrail(changedValueArr, 0);
                  }
                  // self.service.showSuccess("Updated successfully");
                  // self.dialogRef.close({});
                }
              } else {
                if (index === sensorSettingsArr.length - 1) {
                  if (Object.keys(changedValues).length != 0) {
                    //self.auditTrail(changedValues, 0);
                  }
                  // self.service.showSuccess("Updated successfully");
                  // self.dialogRef.close({isChanged:false,graphToReload});
                }
              }
            } else {
              self.service.showError("Something went wrong.");
              // self.dialogRef.close({isChange:false,graphToReload});
            }
          }).catch((err)=>{
              console.log(err);
              // self.dialogRef.close({isChange:false,graphToReload});
          })
          // self.dialogRef.close({isChanged:false,graphToReload});
        return;
      });
      let checkCorrectValues=Object.values(this.correctMetricValues).filter(metric=>metric==false)
      if(checkCorrectValues.length==0){
        self.service.showSuccess("Updated successfully");
        self.dialogRef.close({isChanged:false,graphToReload});
      }

    }
    // console.log(graphToReload);

  }

  compareSensorChanges(currType,sensors,kwSensor){
    // console.log(currType)
    // console.log(sensors)
    // console.log(kwSensor);
    let currSensorOld=[];
    if(currType.metric_type.startsWith('kwrati')){
      currSensorOld=kwSensor.filter(sensor=>sensor.metric_type==currType.metric_type)
    }else{
       currSensorOld=sensors.filter(sensor=>sensor.metric_type==currType.metric_type)
    }
    let th1_old=currSensorOld[0].threshold_1
    let th2_old=currSensorOld[0].threshold_2
    let th3_old=currSensorOld[0].threshold_3
    let base_old=currSensorOld[0].base_value
    let max_old=currSensorOld[0].max_value

    let th1_new=currType.threshold_1
    let th2_new=currType.threshold_2
    let th3_new=currType.threshold_3
    let base_new=currType.base_value
    let max_new=currType.max_value
    // console.log(th1_old, th2_old, th3_old,base_old, max_old);
    // console.log(th1_new, th2_new, th3_new,base_new, max_new);
    if(th1_old==th1_new && th2_old==th2_new && th3_old==th3_new && base_old==base_new && max_old==max_new){
      return false;
    }else{
      return true;
    }
  }

  onInputChange(event: any, sensor: any, field: string) {
    console.log("activates");
    this.disableSensor=false;
  }

  async auditTrail(body, val) {
    let arrSensorGroupData = this.unchangedValueArr;
    let getMacAddress = await this.service
      .getDataWithQuery(
        this.getInventoryByIDUrl + "/" + this.assetData.inventory_id
      )
      .then((mRes) => {
        return JSON.parse(JSON.stringify(mRes));
      });
    let newObject = {};
    let i = 0;
    let forEmptyObj = true;
    if (val === 4) {
      arrSensorGroupData.forEach((key, index) => {
        if (
          arrSensorGroupData[index]["mechanical_health"] !=
            body["Mechanical_Health"] &&
          body["Mechanical_Health"] != undefined
        ) {
          forEmptyObj = false;
          newObject["old_mechanical_health"] =
            arrSensorGroupData[index]["mechanical_health"];
          newObject["new_mechanical_health"] = body["Mechanical_Health"];
        }
        if (
          arrSensorGroupData[index]["bearing_health"] !=
            body["Bearings_Health"] &&
          body["Bearings_Health"] != undefined
        ) {
          forEmptyObj = false;
          newObject["old_bearing_health"] =
            arrSensorGroupData[index]["bearing_health"];
          newObject["new_bearing_health"] = body["Bearings_Health"];
        }
        if (
          arrSensorGroupData[index]["thermal_health"] !=
            body["Thermal_Health"] &&
          body["Thermal_Health"] != undefined
        ) {
          forEmptyObj = false;
          newObject["old_thermal_health"] =
            arrSensorGroupData[index]["thermal_health"];
          newObject["new_thermal_health"] = body["Thermal_Health"];
        }
        if (
          arrSensorGroupData[index]["electrical_health"] !=
            body["Electrical_Health"] &&
          body["Electrical_Health"] != undefined
        ) {
          forEmptyObj = false;
          newObject["old_electrical_health"] =
            arrSensorGroupData[index]["electrical_health"];
          newObject["new_electrical_health"] = body["Electrical_Health"];
        }
      });
    } else {
      arrSensorGroupData.forEach((key, index) => {
        if (
          arrSensorGroupData[index]["base_value"] != body[index]["base_value"]
        ) {
          forEmptyObj = false;
          i++;
          newObject["old_base_value_" + i] =
            arrSensorGroupData[index]["base_value"];
          newObject["base_value_" + i] = body[index]["base_value"];
        }
        if (
          arrSensorGroupData[index]["max_value"] != body[index]["max_value"]
        ) {
          forEmptyObj = false;
          newObject["old_max_value_" + i] =
            arrSensorGroupData[index]["max_value"];
          newObject["max_value" + i] = body[index]["max_value"];
        }
        if (
          arrSensorGroupData[index]["threshold_1"] != body[index]["threshold_1"]
        ) {
          newObject["old_threshold_1" + i] =
            arrSensorGroupData[index]["threshold_1"];
          newObject["threshold_1" + i] = body[index]["threshold_1"];
        }
        if (
          arrSensorGroupData[index]["threshold_2"] != body[index]["threshold_2"]
        ) {
          forEmptyObj = false;
          newObject["old_threshold_2" + i] =
            arrSensorGroupData[index]["threshold_2"];
          newObject["threshold_2" + i] = body[index]["threshold_2"];
        }
        if (
          arrSensorGroupData[index]["threshold_3"] != body[index]["threshold_3"]
        ) {
          forEmptyObj = false;
          newObject["old_threshold_3" + i] =
            arrSensorGroupData[index]["threshold_3"];
          newObject["threshold_3" + i] = body[index]["threshold_3"];
        }
        if (this.commentOnSetting != "") {
          forEmptyObj = false;
          newObject["comment"] = this.commentOnSetting;
        }
      });
    }
    console.log(newObject,'object======');
    let payload = {
      client: localStorage.getItem("user_name"),
      site: this.assetData.site === undefined ? "" : this.assetData.site.name,
      application:
        this.assetData.application === undefined
          ? ""
          : this.assetData.application.name,
      mac_address:
        getMacAddress.length === 0 ? "" : getMacAddress[0].mac_address,
      serial_number:
        this.assetData === undefined ? "" : this.assetData.motor_serial_no,
      by_user: JSON.parse(localStorage.getItem("user_id")),
      belong_to:
        localStorage.getItem("role") === "CLIENT"
          ? localStorage.getItem("user_id")
          : localStorage.getItem("associated_clientid"),
      module: val === 1 ? "EDIT ALERT" : "EDIT SETTINGS",
      updated_obj: JSON.stringify(newObject),
    };
    if (val === 2) {
      payload["module"] = "EDIT ALERT MASTER";
    }
    if (val === 3) {
      payload["module"] = "EDIT ALERT ASSET";
      payload["serial_number"] = localStorage.getItem("AssetSerialNumber");
      payload["mac_address"] = localStorage.getItem("MacAddress");
      payload["site"] = localStorage.getItem("SiteName");
      payload["application"] = localStorage.getItem("ApplicationName");
    }
    if (val === 4) {
      payload["module"] = "Update Indices Weightage";
      payload["serial_number"] = localStorage.getItem("AssetSerialNumber");
      payload["mac_address"] = localStorage.getItem("MacAddress");
      payload["site"] = localStorage.getItem("SiteName");
      payload["application"] = localStorage.getItem("ApplicationName");
    }
    if (localStorage.getItem("role") === "ACCOUNT_MANAGER") {
      payload["belong_to"] = JSON.parse(
        localStorage.getItem("admin_client_id")
      );
    }
    if (!forEmptyObj) {
      this.service
        .postData(this.middleware_url + "v1/audit/trail", payload)
        .then((res) => {});
    }
  }

  onDateSelect(ev) {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    this.poDateFronSelectDate =
      ev.day + " " + monthNames[ev.month - 1] + " " + ev.year;
  }

  async updatePODate() {
    let po_number = parseFloat(
      (<HTMLInputElement>document.getElementById("po_num")).value
    );
    let body = {
      po: po_number,
      po_date: this.poDateFronSelectDate,
    };
    await this.service
      .putData(
        this.createLicenceUrl + "/po/update/" + this.data.selectedLicenceID,
        body
      )
      .then((res) => {
        this.changeService.loader(false);
        const result = JSON.parse(JSON.stringify(res));
        if (result.data.status === "success") {
          this.service.showSuccess("licence updated successfully");
          this.dialogRef.close("poDialogClose");
        } else {
          this.service.showError("Something went wrong.");
        }
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selectedClient(value) {
    this.selectedClientName = value;
    this._clienId = value;
    this.checkStatus(value);
  }

  checkStatus(value) {
    this.service
      .getData(this.checkLicenceAvailability + "/" + value)
      .then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.code == 200) {
          if (
            JSON.parse(JSON.stringify(res)).data.message === "limit exceeded"
          ) {
            this.msgLimit = "This client licence limit exceeded";
            this.makeUpdatedisable = true;
            this.LicenceStatus = true;
          } else {
            this.msgLimit = "";
            this.makeUpdatedisable = false;
            this.LicenceStatus = false;
          }
        }
      });
  }

  associateDevices() {
    const body = {
      client_id: this._clienId,
      devices: this._deviceIds,
    };
    this.changeService.loader(true);
    this.service.postData(this.associateDevicesInfo, body).then((res) => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === "fail") {
        const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
        this.service.showError(msgErr);
      } else if (JSON.parse(JSON.stringify(res)).data.status === "success") {
        this.service.showSuccess("devices associated successfully");
      } else {
        this.service.showError("Something went wrong.");
      }
    });
  }

  associateSiteUser(user) {
    if (user.checked === false) {
      const body = {
        user_id: user.userid,
        client_site_id: this.siteId,
      };
      this.service.postData(this.associateSite, body).then((res) => {
        const resp = JSON.parse(JSON.stringify(res)).data;
        if (resp.status === "success") {
          this._associateUsers++;
          user.checked = true;
          user.id = resp.body.id;
        }
      });
    } else {
      if (user.id !== null) {
        this.removeSite(user);
      }
    }
  }

  selectedClientForMacAdd(clientID) {}

  removeSite(user) {
    this.changeService.loader(true);
    this.service
      .deleteInfo(this.associateSite + "?m=s&id=" + user.id)
      .then((res) => {
        this._associateUsers--;
        user.checked = false;
        this.changeService.loader(false);
      });
  }

  selectAll() {
    if (!this.isChecked) {
      this.postCheckedData = [];
      for (let i = 0; i < this.userList.length; i++) {
        if (this.userList[i].id !== null) {
          this.removeApplication(this.userList[i], 0);
        }
        this.userList[i].checked = true;
        this.postCheckedData.push(this.userList[i]);
      }
    } else {
      for (let i = 0; i < this.userList.length; i++) {
        this.userList[i].checked = false;
        if (this.userList[i].id !== null) {
          this.removeApplication(this.userList[i], i);
        }
      }
      this.postCheckedData = [];
    }
    this._associateUsers = this.postCheckedData.length;
  }

  associateApplicationUser(user, value) {
    this.isChecked = false;
    if (user.checked === false) {
      this.postCheckedData.push(user);
    } else {
      this.postCheckedData = this.postCheckedData.filter((x) => {
        return x.userid != user.userid;
      });
      if (user.id !== null) {
        this.removeApplication(user, 1);
      }
    }
    if (value.checked) {
      this._associateUsers++;
    } else {
      this._associateUsers--;
    }
  }

  saveUserAssociation() {
    for (let i = 0; i < this.postCheckedData.length; i++) {
      const body = {
        admin_id: localStorage.getItem("associated_clientid"),
        application_id: this.applicationId,
        user_id: this.postCheckedData[i].userid,
        site_id: this.siteId,
        client_id: localStorage.getItem("user_id"),
        request_type: "END_USER_ASSOCIATION",
      };
      this.service.postData(this.associateSite, body).then((res) => {
        const resp = JSON.parse(JSON.stringify(res));
        if (resp.message.includes("Saved successfully")) {
          this._associateUsers++;
          this.postCheckedData[i].checked = true;
          if (i === this.postCheckedData.length - 1) {
            this.service.showSuccess("Associated Successfully.");
          }
        }
      });
    }
  }

  removeApplication(user, val) {
    this.changeService.loader(true);
    var body = {
      application_id: this.applicationId,
      user_id: user.id,
      client_id: localStorage.getItem("user_id"),
    };
    this.service.postData(this.associateSite + "/delete", body).then((res) => {
      if (val === 1) {
        // this._associateUsers--;
        if (this._associateUsers <= 0) {
          this._associateUsers = 0;
        }
        user.checked = false;
        this.service.showSuccess("Unassociated Successfully.");
      }
    });
  }

  showAssetImage(assetId) {
    this.service
      .getData(
        this.imageAssetUploadUrl +
          "/" +
          assetId +
          "/" +
          localStorage.getItem("mac_address")
      )
      .then((response) => {
        if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
          this._imgUrl = JSON.parse(
            JSON.stringify(response)
          ).data.body[0].relative_url;
        }
      });
  }

  searchData(ev) {
    if (ev === "") {
      this.userList = this._userData;
    } else {
      const term = ev.toLowerCase();
      this.userList = this.userList.filter(
        (tag) =>
          tag.full_name.toLowerCase().indexOf(term) >= 0 &&
          tag.email.toLowerCase().indexOf(term) >= 0
      );
    }
  }

  filterData(val) {
    if (val === "All") {
      this.userList = this._userData;
    } else {
      this.userList = this._userData;
      this.userList = this.userList.filter((tag) => tag.checked == val);
    }
  }

  selectAlertSettings(id, role, catID, typeID, asset_id, clientId, value) {
    this.alertSaveButton = false;
    let body = {
      id: id,
      catId: catID,
      roleId: role,
      alertTypeId: typeID,
      asset_id: "",
      client_id: clientId,
      event_counter: "",
      event_fire_at: "",
    };
    let existingIndex = this.alertSelectionArr.findIndex(item => item.id === id);
    if(existingIndex !== -1) this.alertSelectionArr[existingIndex].event_counter = value;
    else this.alertSelectionArr.push(body);
    this.manageAlertSettingsRow(role, typeID, value);
    this.saveButtonEnabledAlertSettings();
    body["event_counter"] = value;
    let roleType = "";
    if (role === 1) {
      roleType = "Site Incharge";
    } else if (role === 2) {
      roleType = "User";
    } else if (role === 3) {
      roleType = "Client Admin";
    } else if (role === 4) {
      roleType = "Account Manager";
    }
    let auditPayload = {};
    auditPayload["Alert Category"] = this.alertCategory.find(
      (x) => x.id === catID
    ).category;
    auditPayload["Role"] = roleType;
    auditPayload["Event Counter"] = value;
    this.auditAlertArr.push(auditPayload);
  }

  setDefaultSettings() {
    let data = {
      client_id: localStorage.getItem("user_id"),
    };
    this.alertSaveButton = true;
    this.alertSaveButtonDefault = true;

    this.service
      .postData(`${this.alertBaseUrl}alert/settings/set/to/all`, data)
      .then((res) => {
        this.alertSaveButton = false;
        this.alertSaveButtonDefault = false;
        this.service.showSuccess("Updated successfully");
        this.dialogRef.close();
      });
  }

  saveMainAlertSettings() {
    this.auditTrail(this.auditAlertArr, 2);
    this.alertSaveButton = true;

    for (let i = 0; i < this.alertSelectionArr.length; i++) {
      this.service
        .putData(
          `${this.alertBaseUrl}alert/main/settings/${this.alertSelectionArr[i].id}`,
          this.alertSelectionArr[i]
        )
        .then((res) => {
          if (i === this.alertSelectionArr.length - 1) {
            this.alertSaveButton = false;
            this.service.showSuccess("Updated successfully");
            // this.dialogRef.close();
            this.hideAllSetBtn = true;
          }
        });
    }
  }
  saveMainassetAlertSettings() {
    this.auditTrail(this.auditAlertArr, 3);
    this.alertSaveButton = true;
    for (let i = 0; i < this.alertSelectionArr.length; i++) {
      this.service
        .putData(
          `${this.alertBaseUrl}alert/settings/${this.alertSelectionArr[i].id}`,
          this.alertSelectionArr[i]
        )
        .then((res) => {
          if (i === this.alertSelectionArr.length - 1) {
            this.alertSaveButton = false;
            this.service.showSuccess("Updated successfully");
            this.dialogRef.close("AlertSettingsforasset");

            this.hideAllSetBtn = true;
          }
        });
    }
  }

  saveSettings() {
    this.auditTrail(this.auditAlertArr, 1);
    this.alertSaveButton = true;
    for (let i = 0; i < this.alertSelectionArr.length; i++) {
      this.service
        .putData(
          `${this.alertBaseUrl}alert/settings/${this.alertSelectionArr[i].id}`,
          this.alertSelectionArr[i]
        )
        .then((res) => {
          if (i === this.alertSelectionArr.length - 1) {
            this.alertSaveButton = false;
            this.service.showSuccess("Updated successfully");
            this.dialogRef.close();
          }
        });
    }
  }
  maintenanceLogSave() {
    if (this.maintenanceStatus === "createLog") {
      let body = {
        title: this.maintenanceForm.value.title_val,
        description: this.maintenanceForm.value.description,
        start_date: this.maintenanceForm.value.start_date,
        end_date: this.maintenanceForm.value.end_date,
        publish_date: this.maintenanceForm.value.publish_date,
      };
      this.service
        .postData(this.siteMaintenanceApi + "/maintenance", body)
        .then((res) => {
          let response = JSON.parse(JSON.stringify(res)).data;
          if (response.status === "success") {
            this.service.showSuccess("Saved successfully");
            this.dialogRef.close("success");
          } else {
          }
        });
    } else {
      let body = {
        title: this.maintenanceForm.value.title_val,
        description: this.maintenanceForm.value.description,
        start_date: this.maintenanceForm.value.start_date,
        end_date: this.maintenanceForm.value.end_date,
        publish_date: this.maintenanceForm.value.publish_date,
      };
      this.service
        .putData(
          this.siteMaintenanceApi + "/maintenance/" + this.data.values.id,
          body
        )
        .then((res) => {
          let response = JSON.parse(JSON.stringify(res)).data;
          if (response.status === "success") {
            this.service.showSuccess("Saved successfully");
            this.dialogRef.close("success");
          } else {
          }
        });
    }
  }
  confirmReset(): void {
    this.dialogRef.close(true);
  }

  sendAssetOutForService(){
        /*
    SAMPLE OBJ TO SEND
    {
  "asset_id": "91",
  "inventory_id": "31",
  "last_service_date": "2024-10-16",
  "next_service_date": "2025-10-11",
  "service_detail": "Testingsfs",
  "last_service_performed": "Machine NDE Bearing repaired,Machine DE Bearing repaired,Electrical Unbalance Corrected",
  "service_performed_by": "sarthak",
  "user_id": "2",
  "service_category": "Planned Repair/Service",
  "group_id": "a4fd9595-037f-4a5d-bbb7-2f1202296541",
  "out_of_service": "no"
}
    */
    this.service.postData(this.assetServiceUrl+this.outForServiceData.asset_id,this.outForServiceData)
    .then(res=>{
      let response=JSON.parse(JSON.stringify(res))
      // console.log(response)
      if(response.data.code==200 || response.data.status=="success"){
        this.dialogRef.close({outOfServicePassedDB:this.outForServiceData.db_out_of_service,newOutOfService:this.outForServiceData.new_out_of_service});
        this.service.showSuccess(this.outForServiceData.out_of_service=='no'?"Asset back in service":"Asset sent for service")
      }else{
        this.dialogRef.close({outOfServicePassedDB:this.outForServiceData.db_out_of_service,newOutOfService:this.outForServiceData.new_out_of_service});
        this.service.showError("Please try again!")
      }
    //   {
    //     "client": "Enertics Admin",
    //     "site": "Enertics Dev",
    //     "application": "App test",
    //     "mac_address": "E0693A0421EC",
    //     "serial_number": "ELMIN112022-00029",
    //     "by_user": 1,
    //     "belong_to": "null",
    //     "module": "EDIT SETTINGS",
    //     "updated_obj": "{\"old_threshold_20\":5,\"threshold_20\":5.5,\"old_max_value_0\":15,\"max_value0\":12,\"old_threshold_10\":4.5,\"threshold_10\":4.2,\"old_threshold_30\":15,\"threshold_30\":12}"
    // }
    let auditObj={
      client:this.outForServiceData.service_performed_by,
      site:this.outForServiceAuditData.site,
      application:this.outForServiceAuditData.application,
      mac_address:this.outForServiceAuditData.mac_address,
      serial_number:this.outForServiceAuditData.serial_number,
      by_user:this.outForServiceData.user_id,
      belong_to:localStorage.getItem("role") === "CLIENT"
      ? localStorage.getItem("user_id")
      : localStorage.getItem("associated_clientid"),
      module:"OUT FOR SERVICE",
      updated_obj:JSON.stringify({
        mac_address:this.outForServiceAuditData.mac_address,
            serial_number:this.outForServiceAuditData.serial_number,
            OUT_OF_SERVICE:this.outForServiceData.out_of_service,
            client:this.outForServiceData.service_performed_by,
            site:this.outForServiceAuditData.site,
            application:this.outForServiceAuditData.application,
            done_by:this.outForServiceAuditData.doneBy
          })
        }
        this.service.postData(this.middleware_url+'/v1/audit/trail',auditObj).then(res=>{console.log(res)}).catch(err=>console.log(err))
    })
    .catch(err=>{
      console.log(err)
      this.service.showError("Something went wrong please try again")
    })
  }
  CancelOutForService(){
    // console.log(this.outForServiceData)
    this.dialogRef.close({oldServiceValue:this.outForServiceData.out_of_service,isCancelled:true});
  }
  CancelOutForServiceInitialModal(){
    // console.log(this.outForServiceData)
    this.dialogRef.close();
  }
  CloseCheckSensorDataExits(){
    // console.log(this.outForServiceData)
    this.dialogRef.close({navigateBack:true});
  }

  fetchMasterProducts(){
    try {
      Promise.all([this.service.getDataV2(`${this.middleware_url}get-master-products`)]).then(res=>{
      const productsRes:any=res[0];
       const {code,body}=productsRes.data
       if(code==200){
        this.master_products=body.body
       }
      })
    } catch (error) {
      console.log(error)
    }
  }

  async handleProductTypeChange(event:any){
    if(this.data.inventoryData.master_type == 4){
      // this.inventoryForm.get('mac_add')?.disable();
      await this.service.getDataV2(`${this.piezo_srv_url}/api/get-new-piezo-mac`).then((data:any)=>{
        const {code,status,data:mac} = data;

        if(code != 200 && status != 'success') throw Error('Failed to generate MAC');
        this.inventoryForm.get('mac_add').setValue(mac);
      }).catch(err=>{
        this.service.showError('Failed to generate MAC');
        this.inventoryForm.get('mac_add')?.enable();
      })
    }else{
      this.inventoryForm.get('mac_add')?.enable();
    }
  }
}
